var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServalBlueprintIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 551,
    viewBox: "0 0 900 551",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M454.114 64.2061V50.5408",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448.67 42.9487L448.012 42.5688",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M412.49 44.2187L413.416 43.4131",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M446.623 59.1534L446.068 57.9636",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M416.271 95.8362L416.929 96.216",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M410.825 74.5786V88.2439",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M479.128 87.7723L478.725 86.5295",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M427.425 99.5779L428.344 98.8964",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M460.544 102.38V116.045",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M437.415 207.182L439.468 199.085",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M447.203 168.613L451.237 152.721",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M455.102 137.49L460.544 116.045",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M460.543 102.38L459.623 101.542",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M428.345 98.8965L423.202 119.154",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M406.514 184.914L405.241 189.937",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M384.909 205.531V211.272",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M379.65 206.291V208.568",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M434.53 201.936V202.449",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M449.342 258.676V256.9",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M428.7 223.525V221.247",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M362.558 225.271V222.993",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M444.642 259.112V260.828",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M413.577 227.7V233.774",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M415.548 233.394V228.839",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M396.74 224.891V220.336",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M377.028 220.336V224.891",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M331.586 273.861L331.964 275.345",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M332.024 234.87L331.366 235.25",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M391.748 235.747V240.303",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M410.288 236.431V232.853",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M405.687 233.774V227.7",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M464.202 244.023V241.745",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M434.608 202.729V201.892",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9248 247.991L53.2676 248.37",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M340.376 278.973L340.244 279.203",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M380.703 274.466L378.729 275.606",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M340.377 278.973V274.419",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M331.964 249.532L329.265 238.909",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M407.265 119.741L406.606 120.121",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M425.108 189.154V183.189",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M406.512 173.159V190.673",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M368.21 276.667L368.868 277.049",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M334.062 256.501L334.72 256.881",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M380.57 249.337V249.034",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M362.55 241.593V237.038",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M342.838 237.038V241.593",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M329.267 238.909V243.464",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5957 268.668V255.002",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5957 268.668L55.4693 276.932",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M331.965 254.087V249.532",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M402.006 286.006L399.376 287.524",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M380.966 209.327V205.531",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4759 254.07L50.5957 255.002",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M332.884 248.695L331.965 249.532",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M373.342 245.162L368.079 248.198",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M376.101 271.049V276.667",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M374.786 254.652V252.374",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M763.28 250.823L762.442 251.348",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M329.188 238.286V242.841",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M792.346 248.419L791.688 248.039",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M766.703 248.039L766.045 248.419",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M368.21 276.667V266.495",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M797.79 269.676V256.011",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M454.997 251.615V257.688",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M447.107 257.688V251.615",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M340.244 251.87L340.376 253.161",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M426.332 144.416L426.99 144.036",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4693 263.265L50.5957 255.002",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M430.933 144.036L431.591 144.416",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M483.546 99.7379L484.204 99.3584",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M423.043 140.24V142.518",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M433.168 259.663V264.218",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4688 276.932V263.266",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M331.964 275.345V273.83",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M498.345 261.154L504.225 264.549",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M390.518 261.154L396.397 264.549",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M416.877 82.5063L417.504 81.3508",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M340.244 273.128L340.376 274.419",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M794.111 262.422V270.114",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M793.365 261.342L794.112 262.422",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M413.838 149.35V145.555",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M417.784 145.555V151.295",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M412.524 146.314V148.592",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M421.73 150.11V147.832",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M844.533 273.065L849.405 281.329",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M843.651 272.479L844.533 273.065",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M416.074 269.837V269.531",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M429.62 301.951V304.987",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M428.961 158.081L440.796 151.249",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M528.503 272.492V272.189",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M515.487 273.631V271.354",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M410.289 275.149V272.872",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M772.145 301.306L772.803 301.687",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M449.842 295.284V295.403",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M567.978 315.128L568.636 314.747",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M531.924 274.466L521.272 268.318",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M526.664 277.502L516.013 271.355",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M464.729 244.261V241.745",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M421.992 219.587V217.071",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M526.663 277.808V277.502",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M531.923 274.772V274.466",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M427.648 152.767V157.322",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M377.284 247.439V247.136",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M564.317 316.187L558.179 316.706",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M564.316 316.187L564.452 315.96",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M340.376 257.716V253.161",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M469.723 163.395L448.686 151.249",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M448.686 145.175V151.249",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M522.717 277.808V275.531",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M570.813 311.711V309.563",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M558.313 316.479L564.452 315.96",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M447.107 257.689L434.484 264.977",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M465.392 325.994V330.548",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M558.313 296.739V310.404",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M340.376 257.716L340.244 257.944",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M558.314 310.404L741.997 294.865",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M402.793 125.436V129.991",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M490.289 336.582L490.153 336.355",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4746 254.07L56.3479 262.333",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M373.34 245.162V244.858",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M449.841 193.55V199.623",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M368.079 248.198L378.73 254.348",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M414.236 234.153L413.578 233.774",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M426.989 144.036V137.962",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M506.807 314.325L541.783 294.131",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M421.466 217.071L421.73 216.919",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M569.812 284.594L567.116 273.972",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M538.007 265.833L497.251 242.302",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M456.111 218.55L440.185 209.355",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M494.045 317.512V312.958",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M474.334 312.958V317.512",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M377.022 202.495L361.993 211.171",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M472.8 498.768L473.099 497.502",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M450.002 170.228L427.648 157.322",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M521.272 268.319V268.014",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M413.577 227.7L415.549 228.839",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M542.441 295.268L541.783 294.131",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M388.199 180.098L410.553 193.004",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M466.832 258.448L454.997 251.615",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M493.488 312.958V247.613",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M474.891 247.613V312.958",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M375.706 167.571L379.652 165.294",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M499.49 350.443V345.885",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M525.215 270.596V270.29",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M388.199 175.543V180.098",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M361.993 225.596L362.557 225.271",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M433.562 304.228L430.933 305.746",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M472.749 308.933V308.631",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M409.236 174.024L430.277 186.171",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M380.965 205.531L379.651 206.291",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M379.651 208.568L383.594 210.846",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M384.517 251.311L378.729 254.652",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M344.146 166.053L475.64 241.973",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M466.388 324.703L465.469 325.386",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M373.34 244.858L367.552 248.198",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M412.446 43.6619V57.3272",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M398.06 283.729V286.765",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M377.284 247.136L380.572 249.034",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M435.272 280.919L430.013 283.958",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M499.49 330.702L472.576 436.753",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M426.067 281.984L414.235 275.15",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M558.179 295.451L564.317 294.931",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M137.558 298.647V284.982",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M411.019 73.0221L411.938 72.3406",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M416.074 269.531L410.289 272.872",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M473.099 512.685L472.8 512.433",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M472.8 512.433V498.768",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M420.021 271.811L431.857 278.642",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M428.962 203.634L453.275 217.671",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M401.349 174.025L389.514 180.857",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M542.44 299.825V295.268",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M391.748 235.747L405.687 227.7",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M488.982 463.308L488.062 462.471",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M494.312 294.965L508.251 286.919",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M371.498 250.476L374.786 252.374",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M387.541 169.849V167.571",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M394.117 159.22V164.961",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M548.189 213.409L548.126 213.633",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M471.754 334.797L490.152 336.355",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M459.157 335.707L359.316 278.063",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M548.19 208.854V213.409",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M459.158 319.005V314.451",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M359.977 255.666L459.817 313.311",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M401.61 241.442L415.549 233.394",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M430.014 284.261V283.959",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M441.216 40.1261L426.902 37.3125",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M343.492 171.747L474.987 247.667",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M343.492 167.192L344.147 166.053",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M489.177 475.418V461.753",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M507.465 320.019L542.441 299.825",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M471.755 330.242V334.796",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M474.985 243.112L343.49 167.192",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M449.955 295.47L449.842 295.284",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M446.714 314.857V313.339",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M848.526 280.743L843.65 272.479",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M473.833 445.473L499.491 344.367",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M439.458 433.953L465.509 331.301",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M434.879 140.24L430.933 137.962",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M102.21 280.321V293.986",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M425.411 219.349L428.699 221.247",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M417.784 145.554L421.73 147.832",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M383.991 251.615V251.311",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M461.572 304.76V302.48",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M334.062 277.76L334.72 278.138",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M472.577 442.355V436.753",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M411.209 294.358L398.061 286.765",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M380.95 274.627L378.729 275.909",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M402.926 126.499L403.845 125.663",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M488.982 476.973V463.308",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M127.751 248.645L128.438 249.042",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M507.465 336.721L506.813 335.593",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M373.34 245.162L383.991 251.311",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M474.891 303.793L467.357 299.444",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M388.854 162.257L392.8 164.534",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M558.314 316.479V311.925",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M484.204 70.509L483.546 70.1292",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M446.715 314.858L457.309 320.974",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M473.1 512.685L458.786 509.87",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M490.154 331.798L471.756 330.242",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M499.492 344.367V330.702",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M458.487 495.955L458.786 494.686",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M478.726 101.714L479.129 101.438",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M435.8 280.919L430.015 284.261",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M359.317 282.617L459.158 340.264",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M462.484 214.326L449.843 193.55",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M346.018 258.757L162.859 274.252",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M741.861 279.911L741.997 281.2",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M423.044 142.518L426.99 144.795",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M483.731 454.159L483.073 453.781",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M565.939 272.236L565.281 271.858",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M490.289 336.582L471.891 335.026",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M471.657 435.915L497.394 334.513",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M472.8 498.768L458.486 495.955",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M558.179 295.451L558.314 296.739",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M162.858 287.917L162.724 288.147",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M458.786 509.87L458.486 509.621",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M416.456 450.257L415.798 450.638",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M487.556 506.335V492.671",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M471.891 328.951L490.289 330.51",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M472.577 436.753L471.657 435.915",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M499.491 329.184V324.627",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M474.892 307.699L472.75 308.933",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M481.56 174.784V168.71",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M401.349 174.024V167.951",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M378.729 275.15V272.57",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M483.627 511.271L484.285 510.89",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 282.211L394.116 282.97",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M526.664 277.502L531.923 274.466",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M474.892 247.917L468.146 244.023",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M490.153 331.798L490.289 330.51",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M446.623 59.1533V69.3843",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M846.077 302.005L846.735 301.627",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M741.862 295.095L564.317 310.114",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M498.594 328.173V332.727",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M474.589 303.62V303.318",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M458.487 509.62V495.955",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M359.975 276.923L459.815 334.57",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M430.013 283.958L410.814 272.873",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M471.89 335.026L471.755 334.796",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M567.978 293.87L568.636 293.489",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M495.835 335.521L496.493 335.143",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M428.962 199.078V203.633",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M421.466 219.349V217.071",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M421.731 150.11L420.414 150.869",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M162.724 272.96L340.244 257.944",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M452.894 271.049L466.833 263.003",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M346.017 272.422V258.758",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M412.525 148.591L416.472 150.869",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M432.644 223.525L432.908 223.373",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M416.373 38.7268L415.715 39.1063",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M741.997 281.2L558.314 296.738",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M507.464 335.202V321.537",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M512.223 187.932L489.447 174.784",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M444.894 261.244L449.344 258.676",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M379.652 172.126L375.706 169.849",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M459.815 313.311L459.157 314.451",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M439.496 480.838L440.054 480.507",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M329.187 240.432L158.141 254.902",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M445.004 271.049L433.169 264.218",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M458.943 329.055V318.879",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M555.855 195.662L424.36 119.741",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M498.392 287.297L493.488 290.128",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M499.49 345.885L499.179 345.602",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M489.648 91.7661V78.1008",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M445.886 485.789V499.457",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M430.933 144.795L434.879 142.518",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M451.989 477.818L451.331 478.199",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M418.442 193.004L431.591 185.413",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M50 252.926V266.591",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M346.017 272.422L345.885 272.652",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M384.912 205.531L388.855 207.809",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M404.589 189.561L406.513 181.97",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M422.528 118.873L427.426 99.5781",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M466.015 332.261L440.379 433.269",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M410.353 458.232V471.897",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M391.75 240.303L393.721 241.442",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M339.678 161.877V166.433",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M473.121 190.1L513.647 198.32",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M462.482 216.461V214.326",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9229 281.061L60.5801 281.442",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5645 281.442L86.222 281.061",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M516.012 273.871V271.354",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M558.18 295.451L558.315 295.221",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M343.492 167.192V171.747",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M496.251 237.511L497.177 238.307",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M570.736 285.275L569.813 284.595",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M787.857 289.382L787.99 290.673",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M394.116 159.22L398.059 161.498",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M420.02 272.114V271.811",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M448.685 145.175L471.039 158.081",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M497.176 238.307V242.862",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M359.316 261.36L459.157 319.005",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M475.64 241.973L474.985 243.112",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M340.244 273.128L162.724 288.147",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M376.1 276.667L378.729 275.149",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M515.486 271.355L521.272 268.014",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M439.458 433.953L440.378 433.269",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M440.797 145.175L427.648 152.767",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M474.986 247.667L475.641 248.047",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M564.453 290.147L558.314 290.667",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M474.589 303.318L471.305 301.419",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M498.593 328.173L497.67 327.335",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M417.504 96.5347L416.877 96.1719",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M443.19 166.296L447.168 150.626",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M451.089 135.173L459.624 101.542",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M454.998 257.688L465.517 263.762",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M506.28 281.225V287.297",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M471.039 162.637L457.891 170.228",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M741.996 281.2V294.865",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M431.59 180.857L409.236 167.951",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M412.489 44.2188V57.8841",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M499.49 330.702L499.179 330.419",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M359.975 255.666L359.316 256.805",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M388.199 175.543L401.348 167.951",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M489.448 168.71V174.784",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M341.823 233.29L335.685 233.809",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M497.671 327.335L498.572 323.792",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M458.486 509.621L472.8 512.433",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M359.975 276.923L359.316 278.063",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M361.992 222.667L362.556 222.993",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M489.453 218.814L515.741 203.637",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M329.265 243.464L331.964 254.087",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M542.441 316.527L541.783 315.387",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M394.116 284.488V282.97",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M466.006 194.206L480.244 217.603",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M564.316 294.931L741.861 279.911",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M379.652 171.367V165.294",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M526.664 277.808L532.449 274.466",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M507.969 188.065L471.984 180.765",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M471.755 330.242L471.89 328.951",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M508.252 282.362L506.28 281.225",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M433.168 259.662L447.107 251.615",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M469.891 175.448L481.559 168.71",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M388.854 210.087L387.541 210.846",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M542.44 321.081V316.527",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M383.595 165.294L387.541 167.571",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M387.541 169.849L383.595 172.126",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M443.87 259.559L450.159 269.896",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M555.854 195.662L556.51 196.042",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M440.054 466.842L439.496 465.652",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M487.512 492.113L486.586 491.398",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M396.746 164.534L398.059 163.775",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M432.643 223.525V223.221",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M462.099 304.996V302.48",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M430.933 137.962V144.036",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M440.797 151.248V145.175",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M107.658 301.579L108.315 301.957",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M133.3 301.957L133.957 301.579",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M388.855 159.979L390.172 159.22",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M498.392 287.297V281.225",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M426.99 137.962L423.044 140.24",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M460.544 102.38L452.075 135.743",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M448.205 151.001L444.18 166.866",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M435.405 201.431L434.876 203.516",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M837.96 288.528L837.878 289.823",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M440.633 192.34L428.962 199.078",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M413.839 145.554L412.525 146.314",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M498.594 332.727L499.491 329.184",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M499.491 324.627L498.594 328.173",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M106.635 273.471L105.89 273.909",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M499.491 324.627L498.571 323.792",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M555.855 211.605L556.51 211.225",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M467.573 333.584L468.231 333.965",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M330.189 238.072L332.885 248.695",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M513.648 204.394V198.32",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M473.122 190.099V196.173",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M513.648 204.394L473.122 196.173",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9902 279.883V266.216",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M498.595 349.429V353.986",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M472.749 308.631L462.098 302.48",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M410.814 272.873L416.074 269.837",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M466.832 263.003V258.448",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M464.202 241.745L464.464 241.594",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M492.735 248.047L493.394 247.667",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M489.447 168.71L513.763 182.748",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M741.997 294.865L741.861 295.095",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M558.178 310.634L564.316 310.114",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M542.44 301.343L507.464 321.537",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M507.466 315.465L506.808 314.325",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M498.593 349.429L498.278 349.145",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M506.812 320.407L507.464 321.537",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M345.926 257.88L346.017 258.757",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M564.452 315.96V311.406",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M440.633 198.414V192.34",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M430.277 204.392L440.632 198.414",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M496.429 356.436L496.492 356.398",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M498.593 353.986L499.49 350.443",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M542.441 295.268L507.465 315.465",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M459.816 334.57L459.158 335.707",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M431.592 185.413V180.857",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M458.785 494.686L473.099 497.502",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M382.674 277.883L394.115 284.487",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M127.855 248.691L127.197 248.311",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M499.489 345.885L498.592 349.429",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M162.724 272.961L162.858 274.252",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2432 265.136L87.9892 266.216",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M471.304 301.721V301.419",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M396.746 282.969L394.116 284.487",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M429.618 304.987L442.767 312.58",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M737.278 261.851L568.413 276.135",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M345.884 272.652L340.253 273.128",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M507.464 320.019V315.465",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M459.157 314.451L359.316 256.805",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M376.098 276.668L375.443 277.049",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M560.323 205.911V201.356",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M459.157 340.264V335.707",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M440.054 480.507V466.842",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M435.271 281.225V280.919",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M359.316 256.805V261.36",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M431.855 278.948V278.642",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M507.464 341.278V336.721",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M330.187 238.072L329.265 238.909",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M541.782 300.203L542.44 301.343",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M388.854 159.979V162.257",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M542.44 301.343V315.008",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M556.604 276.516V211.171",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M538.007 214.575V276.516",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M507.465 335.202L542.441 315.009",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M468.804 308.933V306.656",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M516.012 271.354L521.271 268.318",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M513.764 187.303V182.748",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M558.314 290.667L558.179 289.376",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M493.489 284.056L498.393 281.225",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M162.859 287.917L346.018 272.422",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M162.859 287.917V274.252",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M378.729 275.909V275.606",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M474.985 243.112V247.667",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M368.079 250.714V248.198",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M378.73 254.652V254.348",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M410.815 275.389V272.873",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M812.759 269.676L812.013 270.114",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M558.179 289.375L564.317 288.856",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M474.891 307.393L472.749 308.631",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M467.358 299.444L462.099 302.48",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M522.972 297.775V293.218",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M503.261 293.218V297.775",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M479.128 87.7725V101.438",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M457.309 317.938V326.775",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M542.441 316.527L507.465 336.72",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M837.878 303.488L837.96 303.715",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M449.842 199.623L460.909 217.81",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M507.466 341.277L542.442 321.081",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M490.152 336.355V331.798",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M359.316 278.063V282.617",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M548.125 207.56L548.188 208.854",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M467.358 299.444V299.142",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M558.314 310.404L558.179 310.634",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M850.001 297.072V283.404",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M469.89 175.448V180.003",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M367.552 250.476V248.198",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M409.237 167.951V174.024",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M468.803 306.656L465.515 304.76",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M564.131 294.931C564.131 294.829 564.214 294.746 564.316 294.746C564.418 294.746 564.501 294.829 564.501 294.931C564.501 295.033 564.418 295.116 564.316 295.116C564.214 295.116 564.131 295.033 564.131 294.931Z",
    stroke: "#50226D"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M558.314 295.221V290.667",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M467.359 299.142L461.573 302.48",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M415.798 479.487L416.456 479.868",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M444.432 292.279L450.311 295.677",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M481.56 174.784L471.432 180.632",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M837.878 289.823V303.488",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M557.161 281.07V276.516",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M537.45 276.516V281.07",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M558.314 295.221L564.453 294.701",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M375.706 167.572V169.849",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M570.814 290.452V285.899",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M434.879 142.518V140.24",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M379.651 171.367L378.993 171.747",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M787.99 290.673V304.338",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M564.452 294.701V290.147",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M384.253 171.747L383.595 171.367",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M398.06 163.775V161.498",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M383.595 165.294V171.367",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M344.147 156.183L343.492 156.563",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M508.253 286.919V282.362",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M361.993 237.038V182.43",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M343.396 171.692V237.038",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M451.33 507.047L451.988 507.429",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M506.28 287.297L506.938 287.678",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M388.854 210.087V207.809",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M840.08 268.936L839.422 268.555",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M814.438 268.555L813.779 268.936",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M558.315 311.925L558.18 310.634",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M528.503 272.189L525.215 270.29",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M426.067 284.261V281.984",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M522.718 275.531L519.43 273.632",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M568.04 274.652L570.736 285.275",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M568.039 274.652L567.116 273.972",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M564.452 290.147L564.316 288.856",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M136.72 283.99L137.557 284.982",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M416.074 269.837L435.273 280.919",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M772.251 286.169L771.564 287.291",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M558.179 316.706L558.314 316.479",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M771.564 287.291V300.956",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M416.877 82.5063V96.1717",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M564.453 311.406L558.314 311.925",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M471.039 162.636V158.081",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M848.526 280.743L849.405 281.329",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M787.989 304.338L787.856 304.565",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M390.171 163.016V159.22",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3487 262.333L55.4688 263.265",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M402.925 126.499V131.053",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M383.992 251.311L378.729 254.348",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M564.453 311.406L564.317 310.115",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M412.49 44.2188L412.449 43.5952L412.512 42.9726L412.679 42.3562L412.95 41.7519L413.318 41.1658L413.785 40.603L414.342 40.0689L414.988 39.5684L415.715 39.1064",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M450.73 70.3824L451.505 69.6924L452.185 68.9699L452.768 68.2194L453.25 67.4453L453.628 66.6523L453.899 65.8451L454.062 65.0282L454.116 64.2065",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M448.67 42.949L449.7 43.594L450.635 44.2856L451.467 45.0187L452.194 45.7887L452.812 46.5906L453.312 47.4188L453.693 48.2679L453.955 49.1321L454.093 50.0057L454.106 50.8828L453.996 51.7577L453.763 52.6247L453.407 53.4775L452.931 54.3109L452.342 55.1187L451.637 55.8962L450.827 56.6382L449.914 57.3393L448.903 57.995L447.804 58.6009L446.623 59.153",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M446.623 59.1533L445.776 59.5568L445.001 60.0068L444.305 60.4984L443.698 61.0272L443.184 61.5878L442.765 62.1751L442.45 62.7833L442.243 63.4062L442.139 64.038L442.145 64.6725L442.262 65.304L442.482 65.9253L442.806 66.5316L443.235 67.1161L443.761 67.6735L444.378 68.1985L445.083 68.6861",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M417.505 96.5347L416.929 96.2159",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M416.878 82.506L415.804 81.8916L414.821 81.2286L413.933 80.5216L413.149 79.7755L412.469 78.9948L411.905 78.1851L411.455 77.3515L411.124 76.4996L410.913 75.6348L410.828 74.7634L410.863 73.8904L411.02 73.0221",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M479.128 101.438L480.356 101.063L481.534 100.635L482.652 100.159L483.707 99.6348L484.69 99.067L485.597 98.4585L486.422 97.8126L487.159 97.133L487.811 96.4234L488.365 95.6877L488.825 94.93L489.184 94.1546L489.442 93.366L489.599 92.5683L489.65 91.7665",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M484.205 70.5088L485.247 71.1635L486.195 71.8658L487.036 72.6113L487.77 73.3942L488.387 74.2096L488.885 75.0517L489.259 75.915L489.511 76.793L489.637 77.6802L489.631 78.5698L489.502 79.4567L489.244 80.3341L488.859 81.1961L488.355 82.037L487.732 82.8507L486.992 83.6318L486.145 84.375L485.194 85.0748L484.142 85.727L483.005 86.3267L481.783 86.8696L480.488 87.3527L479.128 87.7719",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M478.725 101.714L477.081 102.203L475.485 102.743L473.941 103.331L472.455 103.967L471.031 104.648L469.671 105.371",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M427.425 99.5775L427.639 98.537L427.756 97.4911L427.771 96.4433L427.693 95.3965L427.513 94.3537L427.239 93.3179L426.864 92.2925L426.395 91.28L425.831 90.2838L425.176 89.3069L424.43 88.3517L423.595 87.4214L422.673 86.5185L421.668 85.6458L420.585 84.8056L419.423 84.0009L418.185 83.2337L416.878 82.5062",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M460.543 116.045L460.855 115.013L461.264 113.992L461.765 112.985L462.363 111.995L463.053 111.026L463.831 110.08L464.7 109.159L465.651 108.267L466.684 107.406L467.799 106.578L468.989 105.787L470.252 105.034L471.581 104.322L472.98 103.652L474.435 103.027L475.95 102.449L477.515 101.919L479.127 101.438",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M479.127 87.7725L477.42 88.2827L475.77 88.8489L474.173 89.4687L472.646 90.1401L471.185 90.8613L469.799 91.6298L468.492 92.4426L467.267 93.2977L466.127 94.1921L465.081 95.1224L464.127 96.0861L463.273 97.0794L462.518 98.0998L461.866 99.1435L461.318 100.207L460.877 101.287L460.543 102.379",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.1 49.7814L441.046 50.2201L440.892 50.6503L440.637 51.0647L440.287 51.4549L439.849 51.814L439.33 52.1355L438.738 52.413L438.086 52.6413L437.39 52.8164L436.656 52.9351L435.9 52.995H435.141L434.385 52.9351L433.651 52.8164L432.955 52.6413L432.303 52.413L431.711 52.1355L431.192 51.814L430.754 51.4549L430.404 51.0647L430.149 50.6503L429.995 50.2201L429.941 49.7814L429.995 49.3427L430.149 48.9125L430.404 48.498L430.754 48.1078L431.192 47.7488L431.711 47.4276L432.303 47.1501L432.955 46.9215L433.651 46.7464L434.385 46.628L435.141 46.5681H435.9L436.656 46.628L437.39 46.7464L438.086 46.9215L438.738 47.1501L439.33 47.4276L439.849 47.7488L440.287 48.1078L440.637 48.498L440.892 48.9125L441.046 49.3427L441.1 49.7814Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M478.725 86.5292L479.962 86.1494L481.143 85.7138L482.262 85.226L483.307 84.6884L484.277 84.1045L485.165 83.4781L485.962 82.813L486.667 82.1135L487.272 81.3841L487.776 80.6292L488.176 79.8535L488.466 79.0621L488.648 78.26L488.718 77.4518L488.68 76.6434L488.529 75.8391L488.267 75.0442L487.896 74.2638L487.42 73.5026L486.844 72.7656L486.164 72.0577L485.392 71.3828L484.529 70.7453L483.581 70.1495L482.554 69.599L481.455 69.097L480.29 68.6469L479.068 68.2517L477.796 67.9134L476.479 67.6347L475.131 67.4168L473.755 67.2615L472.363 67.1696L470.962 67.1418L469.563 67.1781L468.171 67.2782L466.798 67.4417L465.453 67.6678L464.143 67.9544L462.877 68.3002L461.662 68.7027L460.506 69.1596",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M460.507 69.1593L459.521 69.5407L458.475 69.8647L457.379 70.128L456.246 70.328L455.084 70.4628L453.903 70.5311L452.715 70.5321L451.534 70.4663L450.372 70.334L449.235 70.1362L448.139 69.8754L447.094 69.5536L446.105 69.1741L445.185 68.7404L444.347 68.257L443.592 67.7285L442.93 67.1598L442.37 66.5564L441.913 65.924L441.567 65.2689L441.334 64.5975L441.217 63.9163L441.214 63.2313L441.327 62.5494L441.557 61.8777L441.9 61.222L442.351 60.5887L442.908 59.9843L443.566 59.414L444.316 58.8839L445.154 58.3989L446.07 57.9634",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M426.902 37.3124L425.926 37.1512L424.928 37.0466L423.917 37L422.903 37.011L421.892 37.0806L420.903 37.2072L419.939 37.3899L419.01 37.627L418.125 37.9158L417.297 38.2541L416.531 38.638L415.832 39.0638L415.212 39.5273L414.673 40.0243L414.223 40.5496L413.867 41.0979L413.606 41.6642L413.442 42.2424L413.379 42.8272L413.417 43.413",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M413.417 43.4131L413.792 46.3054L414.054 49.2019L414.195 52.1009L414.224 55.0014L414.136 57.9013L413.928 60.799L413.606 63.6936L413.166 66.5828L412.611 69.4654L411.94 72.3398",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M398.663 203.607C398.663 203.765 398.534 203.894 398.375 203.894C398.217 203.894 398.088 203.765 398.088 203.607C398.088 203.448 398.217 203.319 398.375 203.319C398.534 203.319 398.663 203.448 398.663 203.607Z",
    stroke: "#50226D"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M411.939 72.3406L411.797 73.1018L411.753 73.8671L411.81 74.632L411.964 75.3926L412.219 76.144L412.569 76.8826L413.013 77.6038L413.551 78.3035L414.178 78.9781L414.893 79.6237L415.686 80.2366L416.559 80.8132L417.504 81.3505",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.306 220.336L381.356 220.775L381.51 221.205L381.765 221.619L382.118 222.009L382.556 222.368L383.076 222.69L383.668 222.967L384.316 223.196L385.016 223.371L385.749 223.49L386.502 223.549H387.264L388.02 223.49L388.751 223.371L389.45 223.196L390.102 222.967L390.691 222.69L391.21 222.368L391.651 222.009L392.001 221.619L392.256 221.205L392.41 220.775L392.464 220.336L392.41 219.897L392.256 219.467L392.001 219.053L391.651 218.662L391.21 218.303L390.691 217.982L390.102 217.705L389.45 217.476L388.751 217.301L388.02 217.182L387.264 217.123H386.502L385.749 217.182L385.016 217.301L384.316 217.476L383.668 217.705L383.076 217.982L382.556 218.303L382.118 218.662L381.765 219.053L381.51 219.467L381.356 219.897L381.306 220.336Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M329.266 238.909L329.193 238.411L329.215 237.912L329.341 237.418L329.565 236.935L329.886 236.471L330.296 236.032L330.793 235.623L331.366 235.25",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M331.965 275.345L332.129 275.817L332.387 276.274L332.73 276.712L333.155 277.124L333.659 277.505L334.232 277.855L334.872 278.163L335.565 278.428L336.305 278.649L337.086 278.819L337.892 278.938L338.714 279.001L339.548 279.014L340.377 278.973",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M340.377 274.419L339.539 274.46L338.698 274.447L337.867 274.378L337.051 274.258L336.267 274.082L335.52 273.858L334.821 273.588",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M50 266.591L50.0375 267.119L50.1499 267.644L50.3363 268.161L50.5955 268.668",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5959 255.002L50.308 254.428L50.1134 253.841L50.0142 253.246L50.0107 252.648L50.103 252.053L50.2907 251.466L50.5716 250.89L50.9439 250.333L51.404 249.798L51.9479 249.289L52.5712 248.812L53.2684 248.37",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M455.554 258.01L454.852 257.861L454.124 257.769L453.381 257.733L452.638 257.754L451.904 257.833L451.196 257.967L450.525 258.155L449.904 258.392L449.344 258.676",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 222.614L390.228 222.312L389.557 222.064L388.833 221.873L388.071 221.744L387.28 221.678H386.487L385.699 221.744L384.934 221.873L384.21 222.064L383.542 222.312L382.94 222.614",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M359.975 282.998L358.759 282.346L357.468 281.744L356.107 281.196L354.681 280.708L353.201 280.28L351.667 279.915L350.095 279.612L348.489 279.373L346.855 279.203L345.207 279.102L343.551 279.068L341.894 279.099L340.244 279.203",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.028 220.336L377.079 220.921L377.236 221.5L377.494 222.066L377.85 222.615L378.307 223.139L378.849 223.633L379.479 224.092L380.187 224.512L380.968 224.887L381.809 225.214L382.703 225.49L383.645 225.71L384.618 225.874L385.617 225.979L386.631 226.024L387.645 226.009L388.649 225.934L389.638 225.799L390.596 225.607L391.515 225.359L392.385 225.057L393.197 224.705L393.94 224.307L394.611 223.867L395.2 223.39L395.698 222.88L396.104 222.343L396.413 221.785L396.62 221.212L396.724 220.629V220.043L396.62 219.46L396.413 218.887L396.104 218.328L395.698 217.792L395.2 217.282L394.611 216.804L393.94 216.364L393.197 215.966L392.385 215.614L391.515 215.313L390.596 215.065L389.638 214.872L388.649 214.738L387.645 214.662L386.631 214.647L385.617 214.692L384.618 214.798L383.645 214.961L382.703 215.182L381.809 215.457L380.968 215.784L380.187 216.16L379.479 216.579L378.849 217.039L378.307 217.533L377.85 218.057L377.494 218.605L377.236 219.172L377.079 219.751L377.028 220.336Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M128.438 249.042L129.16 249.484",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M454.998 257.688L454.396 257.387L453.728 257.139L453.004 256.948L452.239 256.819L451.451 256.753H450.655L449.867 256.819L449.105 256.948L448.381 257.139L447.71 257.387L447.108 257.688",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M368.21 276.668L368.811 276.97L369.482 277.219L370.207 277.408L370.969 277.54L371.756 277.603H372.553L373.34 277.54L374.106 277.408L374.83 277.219L375.498 276.97L376.099 276.668",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M756.282 256.432L757.504 255.669L758.651 254.869L759.718 254.034L760.71 253.167L761.62 252.271L762.442 251.348",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M434.435 201.993L434.646 202.858L434.957 203.714L435.37 204.556L435.883 205.379L436.488 206.18L437.187 206.956L437.978 207.703L438.853 208.417L439.807 209.095L440.843 209.734",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M797.46 271.695L797.643 271.027L797.753 270.353L797.791 269.676",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M359.975 261.739L358.763 261.087L357.471 260.487L356.111 259.941L354.684 259.452L353.204 259.024L351.673 258.657L350.099 258.355L348.496 258.117L346.864 257.947L345.217 257.844L343.561 257.808L341.904 257.842L340.254 257.943",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M342.84 241.594L342.89 242.169L343.041 242.739L343.29 243.297L343.637 243.837L344.078 244.355L344.607 244.844L345.218 245.3L345.904 245.718L346.663 246.093L347.482 246.423L348.354 246.702L349.271 246.93L350.225 247.102L351.201 247.218L352.197 247.276H353.195L354.187 247.218L355.166 247.102L356.117 246.93L357.037 246.702L357.909 246.423L358.728 246.093L359.484 245.718L360.174 245.3L360.785 244.844L361.314 244.355L361.752 243.837L362.098 243.297L362.35 242.739L362.501 242.169L362.552 241.594",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M346.018 272.422L347.624 272.315L349.239 272.268L350.855 272.277L352.467 272.343L354.067 272.469L355.651 272.649L357.217 272.888L358.75 273.181L360.249 273.528L361.708 273.931L363.122 274.381L364.485 274.885L365.789 275.433L367.033 276.028L368.211 276.667",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M351.56 258.633L350.172 258.6L348.783 258.61L347.397 258.662L346.018 258.757",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M459.624 101.542L459.945 100.481L460.364 99.4319L460.881 98.3973L461.495 97.3801L462.203 96.384L463.003 95.4111L463.895 94.4651L464.874 93.548L465.938 92.663L467.082 91.8127L468.304 90.9995L469.601 90.2254L470.971 89.4935L472.404 88.8054L473.903 88.1629L475.459 87.5683L477.068 87.0235L478.725 86.5297",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5651 281.442L84.4909 282.012L83.3385 282.532L82.1162 282.992L80.8319 283.395L79.4951 283.732L78.1141 284.006L76.6984 284.214L75.2582 284.352L73.8032 284.421H72.3429L70.8879 284.352L69.4477 284.214L68.0324 284.006L66.6514 283.732L65.3142 283.395L64.0299 282.992L62.8076 282.532L61.6553 282.012L60.5811 281.442",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M430.932 144.036L430.51 143.836L430.028 143.687L429.506 143.595L428.961 143.564L428.416 143.595L427.893 143.687L427.411 143.836L426.989 144.036",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4688 276.932L55.967 277.682L56.5613 278.409L57.2481 279.111L58.0238 279.779L58.8842 280.412L59.8243 281.004L60.8387 281.555L61.9218 282.062L63.0675 282.522L64.2693 282.928L65.5205 283.281L66.8139 283.58L68.143 283.823L69.4994 284.006L70.876 284.132L72.2648 284.198L73.6581 284.201L75.0482 284.147L76.4273 284.031L77.7875 283.858L79.1209 283.624L80.4207 283.335L81.6792 282.988L82.8894 282.588L84.0443 282.138L85.1378 281.64L86.1635 281.096L87.1159 280.51L87.9892 279.883",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M102.542 278.302L101.506 278.025L100.43 277.805L99.3231 277.647L98.1947 277.546L97.0553 277.509L95.9146 277.534L94.783 277.622L93.671 277.77L92.5879 277.978L91.5436 278.242L90.5475 278.564L89.608 278.938L88.7344 279.364",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9892 266.216L87.0478 266.888L86.0161 267.514L84.9006 268.088L83.7083 268.611L82.4473 269.077L81.1255 269.484L79.7514 269.824L78.3342 270.104L76.883 270.315L75.4072 270.457L73.916 270.529L72.4195 270.535L70.927 270.469L69.4487 270.337L67.9937 270.132L66.5718 269.865L65.1917 269.531L63.8627 269.131L62.5935 268.674L61.392 268.161L60.2661 267.59L59.2234 266.97L58.2704 266.304L57.4132 265.596L56.6573 264.85L56.0076 264.072L55.4688 263.266",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M105.889 273.909L106.517 273.367L107.048 272.791L107.474 272.186L107.791 271.559L107.998 270.917L108.091 270.268L108.07 269.616L107.935 268.967L107.686 268.331L107.328 267.712L106.863 267.117L106.295 266.553L105.633 266.024L104.88 265.537L104.047 265.097L103.14 264.707L102.17 264.372L101.146 264.096L100.079 263.881L98.9792 263.729L97.859 263.643L96.7293 263.622L95.6018 263.667L94.4879 263.778L93.3995 263.953L92.347 264.192L91.3417 264.49L90.3941 264.846L89.5135 265.254L88.7092 265.713L87.9893 266.216",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M162.723 288.147L160.954 288.324L159.204 288.553L157.476 288.837L155.777 289.171L154.11 289.555L152.48 289.99L150.891 290.471L149.348 291.001L147.856 291.577L146.417 292.197L145.036 292.862L143.718 293.564",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M840.08 268.936L841.041 269.534L841.922 270.173L842.716 270.854L843.418 271.562L844.026 272.302L844.533 273.065",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M812.013 270.114L812.857 269.506L813.78 268.936",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M401.508 260.574L400.475 260.33L399.404 260.139L398.315 260.001L397.206 259.918L396.088 259.891L394.97 259.918L393.862 260.001L392.769 260.139L391.701 260.33L390.665 260.574",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M509.336 260.574L508.3 260.33L507.233 260.139L506.14 260.001L505.031 259.918L503.913 259.891L502.798 259.918L501.687 260.001L500.597 260.139L499.529 260.33L498.493 260.574",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M846.077 302.005L845.245 302.436L844.342 302.811L843.371 303.126L842.345 303.378L841.28 303.567L840.184 303.683L839.073 303.734L837.961 303.715",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M565.939 272.236L566.566 272.649L567.098 273.106L567.527 273.597L567.842 274.113L568.04 274.652",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M770.841 300.512L769.288 299.693L767.654 298.928L765.94 298.225L764.155 297.583L762.306 297.003L760.401 296.49L758.442 296.046L756.442 295.671L754.404 295.369L752.338 295.139L750.253 294.981L748.153 294.9L746.049 294.89L743.952 294.956L741.86 295.095",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M787.858 304.565L786.494 304.65L785.124 304.672L783.757 304.634L782.397 304.534L781.055 304.376L779.739 304.156L778.457 303.878L777.213 303.545L776.022 303.154L774.882 302.713L773.808 302.222L772.804 301.687",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M331.965 254.088L332.129 254.558L332.387 255.015L332.73 255.453L333.155 255.866L333.659 256.249L334.232 256.597L334.872 256.906L335.565 257.171L336.305 257.39L337.086 257.56L337.892 257.679L338.714 257.745L339.548 257.757L340.377 257.716",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M137.558 298.647L138.442 297.661L139.422 296.707L140.495 295.788L141.659 294.906L142.908 294.062L144.239 293.262L145.647 292.506L147.128 291.8L148.676 291.142L150.288 290.538L151.957 289.986L153.678 289.495L155.445 289.057L157.253 288.683L159.095 288.365L160.965 288.109L162.858 287.917",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M567.976 315.128L567.352 315.443L566.66 315.714L565.916 315.928L565.132 316.089L564.316 316.187",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M569.384 309.686L568.849 310.064L568.244 310.401L567.573 310.7L566.852 310.952L566.083 311.154L565.28 311.308L564.452 311.406",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M402.925 131.054L403.174 132.268",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M413.577 233.774L412.975 233.473L412.304 233.224L411.58 233.033L410.818 232.904L410.03 232.838H409.234L408.446 232.904L407.681 233.033L406.957 233.224L406.289 233.473L405.688 233.774",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M837.878 303.488L838.964 303.513L840.051 303.475L841.125 303.378L842.177 303.22L843.197 303.003L844.177 302.729L845.106 302.401L845.975 302.027L846.775 301.602L847.502 301.135L848.145 300.628L848.702 300.09L849.162 299.52L849.527 298.928L849.789 298.32L849.949 297.699L850 297.073",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M771.565 287.29L770.142 286.443L768.633 285.65L767.043 284.91L765.377 284.226L763.642 283.606L761.846 283.045L759.995 282.551L758.092 282.119L756.149 281.757L754.171 281.464L752.165 281.241L750.14 281.089L748.106 281.011L746.062 281.001L744.024 281.064L741.996 281.2",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M771.565 300.956L772.627 301.576L773.776 302.143L775.001 302.657L776.293 303.11L777.647 303.501L779.048 303.828L780.491 304.086L781.968 304.279L783.464 304.398L784.975 304.449L786.487 304.43L787.989 304.338",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M506.281 287.297L505.679 286.998L505.008 286.749L504.284 286.557L503.522 286.428L502.735 286.361H501.938L501.15 286.428L500.385 286.557L499.661 286.749L498.993 286.998L498.392 287.297",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M558.18 316.706L556.51 316.876L554.86 317.103L553.232 317.383L551.638 317.72L550.083 318.108L548.565 318.545L547.097 319.037L545.68 319.575L544.319 320.161L543.019 320.788L541.784 321.462",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M137.558 284.982L136.882 285.716L136.111 286.421L135.247 287.086L134.296 287.709L133.265 288.292L132.159 288.824L130.984 289.306L129.749 289.734L128.46 290.106L127.125 290.418L125.751 290.669L124.349 290.862L122.925 290.988L121.488 291.051L120.048 291.047L118.611 290.981L117.188 290.852L115.787 290.657L114.416 290.402L113.083 290.087L111.796 289.712L110.564 289.281L109.393 288.796L108.291 288.26L107.264 287.678L106.317 287.051L105.459 286.383L104.692 285.678L104.022 284.941L103.452 284.179L102.987 283.391L102.629 282.585L102.38 281.766L102.241 280.938L102.214 280.107L102.298 279.275L102.494 278.453L102.799 277.638L103.213 276.841L103.732 276.066L104.354 275.316L105.074 274.595L105.889 273.909",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M558.314 311.925L556.695 312.089L555.099 312.306L553.524 312.58L551.981 312.905L550.472 313.279L549.005 313.705L547.584 314.18L546.211 314.7L544.895 315.267L543.635 315.875L542.441 316.526",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M343.396 237.038L343.447 237.599L343.598 238.154L343.85 238.697L344.2 239.222L344.64 239.722L345.173 240.194L345.784 240.63L346.473 241.028L347.229 241.381L348.045 241.687L348.911 241.942L349.821 242.144L350.76 242.289L351.723 242.377L352.693 242.407L353.667 242.377L354.627 242.289L355.569 242.144L356.476 241.942L357.345 241.687L358.161 241.381L358.916 241.028L359.603 240.63L360.217 240.194L360.746 239.722L361.187 239.222L361.537 238.697L361.789 238.154L361.943 237.599L361.993 237.038",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M339.678 166.433L339.728 167.088L339.876 167.738L340.122 168.378L340.462 169.003L340.897 169.609L341.422 170.19L342.033 170.743L342.723 171.263L343.492 171.747",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M383.595 171.367L383.173 171.167L382.691 171.018L382.169 170.926L381.624 170.896L381.079 170.926L380.556 171.018L380.074 171.167L379.652 171.367",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M343.492 167.191L342.632 166.645L341.873 166.053L341.215 165.42L340.67 164.753L340.238 164.059L339.927 163.344L339.741 162.614L339.678 161.877L339.741 161.141L339.927 160.411L340.238 159.696L340.67 159.001L341.215 158.334L341.873 157.702L342.632 157.109L343.492 156.563",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M567.976 293.87L567.352 294.188L566.66 294.455L565.916 294.67L565.132 294.83L564.316 294.931",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M837.96 303.715L832.95 303.498L827.933 303.346L822.913 303.265L817.886 303.249L812.866 303.299L807.846 303.419L802.833 303.605L797.828 303.857L792.837 304.178L787.857 304.565",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M564.452 294.701L565.318 294.597L566.153 294.437L566.953 294.219L567.699 293.945L568.386 293.627L569.003 293.262L569.538 292.856L569.989 292.418L570.345 291.952L570.603 291.464L570.76 290.963L570.814 290.453",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M409.237 174.025L408.635 173.724L407.964 173.475L407.243 173.284L406.478 173.155L405.691 173.089H404.894L404.106 173.155L403.341 173.284L402.62 173.475L401.949 173.724L401.348 174.025",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M556.604 274.63L556.891 275.194L557.077 275.77L557.159 276.356L557.137 276.941L557.007 277.524L556.774 278.094L556.444 278.648L556.015 279.181L555.493 279.685L554.885 280.154L554.195 280.585L553.433 280.976L552.605 281.316L551.72 281.606L550.791 281.839L549.821 282.018L548.825 282.138L547.814 282.201H546.797L545.786 282.138L544.791 282.018L543.824 281.839L542.892 281.606L542.01 281.316L541.182 280.976L540.417 280.585L539.73 280.154L539.119 279.685L538.599 279.181L538.168 278.648L537.837 278.094L537.607 277.524L537.478 276.941L537.453 276.356L537.535 275.77L537.721 275.194L538.007 274.63",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M489.447 174.784L488.845 174.483L488.178 174.234L487.453 174.043L486.688 173.914L485.901 173.849H485.104L484.316 173.914L483.554 174.043L482.83 174.234L482.159 174.483L481.558 174.784",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M741.996 294.865L743.798 294.742L745.608 294.676L747.426 294.667L749.236 294.711L751.044 294.815L752.836 294.975L754.612 295.189L756.367 295.46L758.092 295.785L759.784 296.162L761.44 296.594L763.049 297.076L764.615 297.608L766.126 298.187L767.581 298.814L768.973 299.488L770.302 300.2L771.565 300.956",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M787.99 304.338L792.95 303.951L797.92 303.633L802.902 303.381L807.894 303.195L812.892 303.076L817.893 303.025L822.894 303.041L827.896 303.123L832.89 303.274L837.879 303.488",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M837.879 289.823L832.89 289.609L827.896 289.457L822.894 289.376L817.893 289.36L812.892 289.41L807.894 289.53L802.902 289.716L797.92 289.968L792.95 290.286L787.99 290.673",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.475 77.3414L465.525 77.7802L465.682 78.2104L465.934 78.6248L466.287 79.015L466.725 79.374L467.245 79.6956L467.837 79.9727L468.485 80.2014L469.185 80.3765L469.918 80.4949L470.671 80.555H471.433L472.189 80.4949L472.92 80.3765L473.619 80.2014L474.271 79.9727L474.86 79.6956L475.379 79.374L475.82 79.015L476.17 78.6248L476.425 78.2104L476.579 77.7802L476.633 77.3414L476.579 76.9027L476.425 76.4725L476.17 76.0581L475.82 75.6679L475.379 75.3089L474.86 74.9873L474.271 74.7102L473.619 74.4815L472.92 74.3064L472.189 74.188L471.433 74.1282H470.671L469.918 74.188L469.185 74.3064L468.485 74.4815L467.837 74.7102L467.245 74.9873L466.725 75.3089L466.287 75.6679L465.934 76.0581L465.682 76.4725L465.525 76.9027L465.475 77.3414Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M455.421 291.7L454.385 291.457L453.318 291.265L452.225 291.13L451.116 291.045L450.001 291.016L448.883 291.045L447.775 291.13L446.682 291.265L445.614 291.457L444.578 291.7",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M340.377 253.161L339.548 253.202L338.714 253.19L337.892 253.124L337.086 253.005L336.305 252.835L335.565 252.616L334.872 252.35L334.232 252.042L333.659 251.694L333.155 251.311L332.73 250.898L332.387 250.46L332.129 250.003L331.965 249.532",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M474.891 303.167L474.589 303.318",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M410.824 88.2441L410.878 89.0542L411.035 89.8594L411.3 90.6556L411.665 91.4382L412.134 92.2022L412.698 92.9439L413.363 93.6588L414.115 94.3428L414.956 94.9919L415.879 95.6029L416.877 96.1717",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M503.261 297.775L503.311 298.351L503.462 298.921L503.714 299.479L504.061 300.017L504.502 300.537L505.028 301.025L505.638 301.482L506.328 301.898L507.084 302.275L507.906 302.603L508.778 302.883L509.695 303.11L510.649 303.283L511.625 303.4L512.617 303.456H513.616L514.611 303.4L515.587 303.283L516.541 303.11L517.458 302.883L518.33 302.603L519.152 302.275L519.908 301.898L520.598 301.482L521.209 301.025L521.735 300.537L522.176 300.017L522.522 299.479L522.771 298.921L522.922 298.351L522.972 297.775",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.972 293.218L522.922 293.804L522.764 294.383L522.506 294.95L522.15 295.498L521.697 296.021L521.152 296.515L520.522 296.975L519.814 297.394L519.033 297.772L518.192 298.096L517.297 298.373L516.356 298.594L515.382 298.757L514.384 298.861L513.373 298.909L512.356 298.893L511.351 298.817L510.362 298.682L509.405 298.49L508.485 298.241L507.616 297.942L506.804 297.589L506.06 297.192L505.39 296.751L504.801 296.273L504.303 295.762L503.897 295.227L503.588 294.67L503.38 294.096L503.276 293.511V292.925L503.38 292.342L503.588 291.769L503.897 291.212L504.303 290.676L504.801 290.166L505.39 289.687L506.06 289.246L506.804 288.85L507.616 288.497L508.485 288.198L509.405 287.949L510.362 287.757L511.351 287.621L512.356 287.546L513.373 287.53L514.384 287.577L515.382 287.681L516.356 287.845L517.297 288.065L518.192 288.339L519.033 288.667L519.814 289.042L520.522 289.464L521.152 289.924L521.697 290.418L522.15 290.941L522.506 291.489L522.764 292.056L522.922 292.635L522.972 293.218Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.695 293.218L518.645 293.659L518.49 294.087L518.235 294.503L517.886 294.893L517.445 295.252L516.925 295.573L516.336 295.851L515.684 296.08L514.985 296.254L514.251 296.373L513.499 296.433H512.736L511.984 296.373L511.25 296.254L510.551 296.08L509.899 295.851L509.31 295.573L508.79 295.252L508.349 294.893L508 294.503L507.745 294.087L507.59 293.659L507.54 293.218L507.59 292.78L507.745 292.352L508 291.936L508.349 291.545L508.79 291.186L509.31 290.865L509.899 290.588L510.551 290.358L511.25 290.185L511.984 290.065L512.736 290.005H513.499L514.251 290.065L514.985 290.185L515.684 290.358L516.336 290.588L516.925 290.865L517.445 291.186L517.886 291.545L518.235 291.936L518.49 292.352L518.645 292.78L518.695 293.218Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M382.676 277.883L382.632 277.386L382.506 276.86L382.298 276.327L382.024 275.814L381.69 275.342L381.312 274.929L380.909 274.598L380.496 274.359L380.093 274.227L379.718 274.202L379.385 274.29L379.107 274.485L378.903 274.778L378.774 275.156L378.729 275.606",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M446.487 311.689L446.613 312.256L446.689 312.807L446.714 313.339",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M558.18 310.634L556.51 310.804L554.86 311.031L553.232 311.311L551.638 311.645L550.083 312.032L548.565 312.473L547.097 312.961L545.68 313.5L544.319 314.086L543.019 314.716L541.784 315.386",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M340.54 257.943C340.54 258.102 340.412 258.23 340.253 258.23C340.094 258.23 339.966 258.102 339.966 257.943C339.966 257.784 340.094 257.656 340.253 257.656C340.412 257.656 340.54 257.784 340.54 257.943Z",
    stroke: "#50226D"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M499.491 350.442L499.778 349.507L500.156 348.584L500.628 347.677L501.189 346.786L501.841 345.914L502.578 345.066L503.396 344.245L504.3 343.454L505.28 342.692L506.338 341.968L507.465 341.278",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M507.465 336.721L506.228 337.483L505.078 338.286L504.02 339.133L503.059 340.015L502.197 340.931L501.438 341.879L500.786 342.852L500.244 343.848L499.809 344.859L499.491 345.885",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M459.158 340.264L460.119 340.853L461.013 341.476L461.835 342.131L462.588 342.815",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M463.495 339.24L462.799 338.469L462.011 337.725L461.139 337.017L460.188 336.343L459.158 335.707",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M375.445 277.049L374.888 277.323L374.267 277.543L373.593 277.704L372.885 277.801L372.157 277.833L371.43 277.801L370.721 277.704L370.047 277.543L369.423 277.323L368.869 277.049",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435 73.8193L434.946 74.2577L434.792 74.6882L434.537 75.1023L434.187 75.4929L433.75 75.8519L433.23 76.1731L432.638 76.4506L431.986 76.6789L431.29 76.854L430.556 76.9727L429.8 77.0326H429.041L428.286 76.9727L427.552 76.854L426.856 76.6789L426.204 76.4506L425.612 76.1731L425.092 75.8519L424.654 75.4929L424.305 75.1023L424.05 74.6882L423.895 74.2577L423.842 73.8193L423.895 73.3806L424.05 72.9501L424.305 72.5359L424.654 72.1457L425.092 71.7864L425.612 71.4652L426.204 71.1877L426.856 70.9594L427.552 70.7843L428.286 70.6655L429.041 70.6057H429.8L430.556 70.6655L431.29 70.7843L431.986 70.9594L432.638 71.1877L433.23 71.4652L433.75 71.7864L434.187 72.1457L434.537 72.5359L434.792 72.9501L434.946 73.3806L435 73.8193Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M368.869 277.049L367.559 276.34L366.17 275.685L364.712 275.083L363.184 274.542L361.6 274.057L359.962 273.635L358.277 273.276L356.558 272.983L354.807 272.759L353.037 272.599L351.248 272.51L349.456 272.488L347.664 272.536L345.885 272.652",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M411.021 73.0214L411.688 70.1593L412.242 67.289L412.677 64.412L412.998 61.5301L413.203 58.6446L413.294 55.7573L413.266 52.8694L413.124 49.9827L412.866 47.0985L412.491 44.2188",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M402.794 129.991L402.829 130.524L402.926 131.054",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M452.119 271.424L451.606 271.178L451.146 270.898L450.749 270.589L450.418 270.252L450.16 269.896",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M570.736 285.275L570.808 285.754L570.79 286.235L570.679 286.714L570.475 287.18L570.182 287.631L569.801 288.059L569.341 288.462L568.805 288.83L568.204 289.164L567.539 289.457L566.825 289.703L566.066 289.901L565.272 290.049L564.453 290.147",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M446.715 313.522L445.984 313.494L445.269 313.412L444.579 313.276L443.924 313.091L443.317 312.857L442.769 312.58",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M417.505 81.3507L418.925 82.1437L420.264 82.9821L421.517 83.8639L422.679 84.7854L423.75 85.744L424.723 86.7367L425.596 87.7596L426.364 88.8099L427.028 89.8842L427.583 90.9786L428.03 92.0893L428.364 93.2133L428.587 94.3462L428.695 95.485L428.691 96.6253L428.575 97.7635L428.345 98.896",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M429.62 304.987L429.119 304.656L428.7 304.288L428.372 303.888L428.143 303.469L428.013 303.034L427.988 302.597L428.067 302.159L428.25 301.731L428.53 301.321",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M446.12 293.256L446.832 293.404L447.503 293.608L448.123 293.863L448.674 294.163L449.15 294.506L449.54 294.881L449.843 295.284",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M417.558 294.988L416.849 295.148L416.109 295.255L415.35 295.3L414.588 295.284L413.839 295.211L413.111 295.076L412.421 294.89L411.785 294.648L411.209 294.358",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M398.06 286.764L397.559 286.434L397.14 286.065L396.813 285.669L396.583 285.25L396.454 284.815L396.429 284.374L396.507 283.936L396.69 283.508L396.97 283.099",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M473.121 196.173L472.41 196.059L471.679 196L470.939 195.997L470.205 196.05L469.493 196.159L468.81 196.322L468.171 196.535L467.585 196.795",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M449.842 199.623L449.545 199.226L449.158 198.854L448.692 198.516L448.147 198.217L447.542 197.962L446.881 197.758L446.179 197.606L445.445 197.509L444.699 197.471L443.949 197.491L443.212 197.568L442.497 197.702L441.823 197.89L441.197 198.129L440.633 198.414",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M507.465 321.537L506.228 322.299L505.078 323.103L504.02 323.95L503.059 324.832L502.197 325.748L501.438 326.696L500.786 327.666L500.244 328.661L499.809 329.675L499.491 330.702",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M507.465 315.465L506.228 316.224L505.078 317.03L504.02 317.874L503.059 318.759L502.197 319.676L501.438 320.621L500.786 321.594L500.244 322.589L499.809 323.6L499.491 324.627",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M459.158 319.005L460.21 319.654L461.18 320.344L462.065 321.071L462.862 321.833L463.567 322.624L464.175 323.443L464.685 324.28L465.092 325.137L465.394 326.009",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M762.442 251.348L763.025 250.709L763.677 250.094L764.401 249.505L765.192 248.946L766.045 248.418",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M792.345 248.418L793.343 249.043L794.253 249.711L795.069 250.418L795.784 251.161L796.398 251.933L796.902 252.732L797.295 253.551L797.576 254.386L797.743 255.23L797.79 256.08L797.724 256.928L797.538 257.772L797.239 258.604L796.826 259.42L796.307 260.215L795.677 260.983L794.943 261.72L794.112 262.421",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M514.202 204.526L513.647 204.394",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M465.469 325.386L465.63 324.535L465.693 323.685L465.658 322.832L465.526 321.981L465.296 321.137L464.972 320.306L464.55 319.487L464.037 318.687L463.432 317.909L462.742 317.153L461.964 316.429L461.104 315.733L460.169 315.072L459.158 314.451",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M556.605 276.516L556.554 277.077L556.403 277.634L556.151 278.176L555.802 278.699L555.361 279.2L554.828 279.672L554.218 280.11L553.528 280.507L552.772 280.859L551.956 281.165L551.09 281.42L550.18 281.621L549.242 281.766L548.278 281.855L547.308 281.886L546.335 281.855L545.374 281.766L544.432 281.621L543.525 281.42L542.659 281.165L541.841 280.859L541.085 280.507L540.398 280.11L539.784 279.672L539.255 279.2L538.814 278.699L538.464 278.176L538.213 277.634L538.061 277.077L538.008 276.516",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M492.735 248.047L491.857 248.507L490.905 248.915L489.888 249.267L488.814 249.56L487.696 249.79L486.547 249.957L485.375 250.057L484.188 250.091L483.004 250.057L481.832 249.957L480.68 249.79L479.565 249.56L478.491 249.267L477.474 248.915L476.519 248.507L475.641 248.047",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M440.055 480.507L440.971 480.155L441.944 479.852L442.965 479.61L444.023 479.424L445.106 479.301L446.205 479.241L447.311 479.244L448.41 479.307L449.493 479.437",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M466.389 324.702L466.326 325.153L466.358 325.606L466.48 326.053L466.698 326.488L467.003 326.904L467.394 327.297L467.863 327.66L468.405 327.987L469.009 328.274L469.671 328.519L470.379 328.715L471.123 328.86L471.891 328.951",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M340.377 257.716L341.848 257.623L343.322 257.587L344.802 257.607L346.273 257.683L347.734 257.816L349.176 258.004L350.593 258.247L351.979 258.544L353.327 258.892L354.634 259.292L355.891 259.74L357.094 260.236L358.237 260.777L359.317 261.36",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M496.251 237.511L496.465 236.116L496.79 234.728L497.215 233.349L497.744 231.982L498.377 230.63L499.111 229.295L499.942 227.979L500.874 226.686L501.901 225.417L503.025 224.175L504.238 222.963L505.545 221.783L506.937 220.636L508.414 219.525L509.973 218.452L511.613 217.42L513.327 216.429L515.116 215.483L516.974 214.582L518.898 213.729L520.885 212.925L522.929 212.172L525.03 211.47L527.181 210.822L529.379 210.229L531.618 209.691L533.895 209.21L536.21 208.787L538.55 208.422L540.918 208.117L543.305 207.871L545.711 207.684L548.127 207.559",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M487.511 492.113L487.555 492.721L487.496 493.329L487.338 493.93L487.083 494.522L486.733 495.095L486.289 495.65L485.76 496.176L485.143 496.67L484.45 497.127L483.685 497.546L482.857 497.924L481.969 498.251L481.03 498.528L480.051 498.755L479.04 498.928L478.004 499.045L476.955 499.105H475.9L474.851 499.048L473.815 498.938L472.801 498.768",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M519.431 273.631L518.977 273.842L518.457 273.997L517.894 274.085L517.311 274.101L516.738 274.047L516.193 273.927L515.702 273.745L515.289 273.505L514.974 273.225L514.763 272.91L514.672 272.576L514.703 272.239L514.855 271.915L515.119 271.616L515.488 271.354",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M413.838 145.554L414.263 145.354L414.745 145.205L415.268 145.114L415.813 145.083L416.357 145.114L416.88 145.205L417.362 145.354L417.784 145.554",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M499.491 344.367L499.778 343.435L500.156 342.512L500.628 341.602L501.189 340.711L501.841 339.842L502.578 338.994L503.396 338.172L504.3 337.379L505.28 336.62L506.338 335.892L507.465 335.203",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M420.415 150.869L419.993 151.069L419.511 151.218L418.988 151.31L418.443 151.341L417.898 151.31L417.376 151.218L416.894 151.069L416.472 150.869",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M440.633 192.34L441.241 192.036L441.918 191.786L442.648 191.595L443.42 191.466L444.217 191.403L445.02 191.407L445.814 191.477L446.585 191.612L447.309 191.81L447.98 192.066L448.582 192.374L449.098 192.73L449.52 193.124L449.842 193.55",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M428.962 203.633L428.442 203.286L428.01 202.899L427.68 202.481L427.456 202.04L427.343 201.585V201.126L427.456 200.671L427.68 200.23L428.01 199.812L428.442 199.426L428.962 199.078",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M488.982 463.308L488.314 466.171L487.763 469.04L487.325 471.919L487.004 474.8L486.799 477.685L486.708 480.573L486.736 483.461L486.878 486.349L487.136 489.231L487.511 492.112",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M471.04 158.081L471.563 158.429L471.991 158.815L472.322 159.233L472.545 159.674L472.659 160.129V160.589L472.545 161.043L472.322 161.484L471.991 161.902L471.563 162.289L471.04 162.636",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M102.211 293.986L102.263 294.789L102.419 295.586L102.677 296.373L103.037 297.151L103.496 297.907L104.052 298.644L104.702 299.353L105.442 300.033L106.267 300.678L107.174 301.289L108.157 301.856L109.211 302.379L110.33 302.855L111.507 303.283L112.736 303.658L114.01 303.979L115.323 304.244L116.666 304.451L118.032 304.603L119.414 304.694L120.803 304.722L122.193 304.694L123.574 304.603L124.941 304.455L126.284 304.247L127.597 303.982L128.871 303.661L130.101 303.286L131.278 302.858L132.397 302.382L133.451 301.859L134.435 301.293L135.342 300.682L136.168 300.036L136.909 299.359L137.559 298.647",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M542.441 321.08L543.758 320.369L545.153 319.704L546.617 319.093L548.148 318.539L549.735 318.041L551.373 317.604L553.058 317.226L554.781 316.914L556.535 316.662L558.314 316.479",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M423.044 142.518L422.698 142.274L422.44 141.995L422.282 141.693L422.229 141.379L422.282 141.065L422.44 140.763L422.698 140.484L423.044 140.24",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M387.541 210.846L387.119 211.046L386.637 211.195L386.111 211.287L385.569 211.317L385.025 211.287L384.502 211.195L384.017 211.046L383.595 210.846",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M359.317 278.063L358.152 277.436L356.914 276.86L355.604 276.334L354.237 275.864L352.814 275.455L351.343 275.102L349.831 274.813L348.291 274.586L346.723 274.422L345.142 274.321L343.552 274.29L341.961 274.321L340.377 274.419",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M390.171 159.22L390.593 159.02L391.075 158.871L391.598 158.779L392.142 158.748L392.687 158.779L393.21 158.871L393.692 159.02L394.117 159.22",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M548.127 207.559L549.226 207.487L550.309 207.357L551.368 207.17L552.391 206.928L553.371 206.633L554.303 206.288L555.172 205.895L555.978 205.458L556.712 204.98L557.367 204.465L557.937 203.918L558.419 203.343L558.806 202.745L559.099 202.129L559.291 201.501L559.386 200.864L559.376 200.226L559.269 199.59L559.058 198.963L558.753 198.35L558.347 197.755L557.852 197.185L557.266 196.643L556.599 196.133L555.855 195.662",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M424.361 119.741L423.464 119.274L422.494 118.86L421.455 118.504L420.362 118.21L419.222 117.981L418.047 117.818L416.85 117.723L415.644 117.698L414.438 117.743L413.247 117.857L412.082 118.038L410.955 118.286L409.874 118.598L408.854 118.97L407.903 119.4L407.031 119.882L406.246 120.411L405.557 120.984L404.971 121.593L404.492 122.233L404.124 122.897L403.875 123.579L403.746 124.272L403.736 124.969L403.847 125.663",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M398.061 161.498L398.407 161.742L398.665 162.02L398.826 162.322L398.879 162.636L398.826 162.95L398.665 163.253L398.407 163.531L398.061 163.775",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M558.314 296.739L556.695 296.906L555.099 297.123L553.524 297.394L551.981 297.718L550.472 298.096L549.005 298.521L547.584 298.994L546.211 299.516L544.895 300.083L543.635 300.691L542.441 301.343",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M490.153 336.355L490.985 336.396L491.819 336.387L492.644 336.321L493.454 336.204L494.235 336.034L494.978 335.817L495.674 335.549L496.313 335.24L496.89 334.894L497.397 334.51L497.822 334.097L498.168 333.656L498.427 333.2L498.594 332.727",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.233 124.676L410.287 125.115L410.441 125.545L410.696 125.96L411.046 126.35L411.487 126.709L412.006 127.03L412.595 127.308L413.247 127.536L413.946 127.711L414.677 127.83L415.433 127.89H416.195L416.948 127.83L417.682 127.711L418.381 127.536L419.029 127.308L419.622 127.03L420.141 126.709L420.579 126.35L420.932 125.96L421.184 125.545L421.341 125.115L421.391 124.676L421.341 124.238L421.184 123.807L420.932 123.393L420.579 123.003L420.141 122.644L419.622 122.322L419.029 122.045L418.381 121.817L417.682 121.641L416.948 121.523L416.195 121.463H415.433L414.677 121.523L413.946 121.641L413.247 121.817L412.595 122.045L412.006 122.322L411.487 122.644L411.046 123.003L410.696 123.393L410.441 123.807L410.287 124.238L410.233 124.676Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M379.652 165.294L380.074 165.093L380.556 164.944L381.079 164.853L381.624 164.822L382.169 164.853L382.691 164.944L383.173 165.093L383.595 165.294",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M772.252 286.169L773.263 286.758L774.353 287.297L775.515 287.785L776.743 288.213L778.028 288.585L779.36 288.897L780.733 289.142L782.135 289.325L783.558 289.438L784.991 289.489L786.427 289.467L787.857 289.382",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M787.99 290.673L786.605 290.758L785.209 290.786L783.814 290.752L782.428 290.657L781.058 290.503L779.711 290.289L778.397 290.018L777.119 289.69L775.89 289.309L774.713 288.878L773.595 288.393L772.546 287.864L771.566 287.291",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M340.254 273.128L341.784 273.03L343.321 272.992L344.861 273.014L346.395 273.093L347.913 273.232L349.415 273.43L350.889 273.682L352.335 273.991L353.739 274.353L355.097 274.772L356.407 275.238L357.66 275.754L358.851 276.318L359.975 276.923",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M498.572 323.792L498.868 322.825L499.259 321.874L499.744 320.936L500.326 320.016L500.997 319.115L501.759 318.24L502.607 317.393L503.539 316.574L504.553 315.786L505.643 315.037L506.808 314.325",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M359.317 256.805L358.152 256.178L356.914 255.602L355.604 255.077L354.237 254.608L352.814 254.197L351.343 253.845L349.831 253.554L348.291 253.327L346.723 253.163L345.142 253.064L343.552 253.031L341.961 253.063L340.377 253.161",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M458.943 329.055L460.162 329.808L461.29 330.608L462.319 331.452L463.245 332.333L464.064 333.25L464.773 334.198",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M387.541 167.571L387.887 167.815L388.146 168.094L388.303 168.396L388.357 168.71L388.303 169.024L388.146 169.327L387.887 169.605L387.541 169.849",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.886 200.596L552.835 201.035L552.678 201.466L552.426 201.88L552.073 202.27L551.635 202.629L551.116 202.951L550.524 203.228L549.875 203.456L549.176 203.631L548.442 203.75L547.689 203.81H546.927L546.171 203.75L545.441 203.631L544.741 203.456L544.09 203.228L543.501 202.951L542.981 202.629L542.54 202.27L542.191 201.88L541.935 201.466L541.781 201.035L541.728 200.596L541.781 200.158L541.935 199.728L542.191 199.313L542.54 198.923L542.981 198.564L543.501 198.243L544.09 197.965L544.741 197.737L545.441 197.561L546.171 197.443L546.927 197.383H547.689L548.442 197.443L549.176 197.561L549.875 197.737L550.524 197.965L551.116 198.243L551.635 198.564L552.073 198.923L552.426 199.313L552.678 199.728L552.835 200.158L552.886 200.596Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M426.99 137.962L427.412 137.762L427.894 137.613L428.417 137.522L428.962 137.491L429.507 137.522L430.029 137.613L430.511 137.762L430.933 137.962",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M481.559 168.71L482.16 168.409L482.831 168.161L483.555 167.97L484.317 167.84L485.105 167.775H485.902L486.689 167.84L487.454 167.97L488.179 168.161L488.846 168.409L489.448 168.71",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M127.751 248.645L126.74 248.055L125.649 247.516L124.486 247.029L123.258 246.598L121.974 246.227L120.641 245.916L119.27 245.67L117.868 245.488L116.445 245.373L115.01 245.325L113.574 245.345L112.146 245.431",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M340.377 278.973L341.848 278.882L343.322 278.844L344.802 278.866L346.273 278.941L347.734 279.074L349.176 279.263L350.593 279.505L351.979 279.801L353.327 280.151L354.634 280.551L355.891 280.998L357.094 281.492L358.237 282.034L359.317 282.617",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M471.985 180.765L471.295 180.594L470.653 180.371L470.067 180.101L469.547 179.788L469.106 179.437L468.753 179.056L468.489 178.65L468.322 178.228L468.256 177.797L468.29 177.364L468.426 176.938L468.656 176.526L468.983 176.136L469.396 175.774L469.89 175.448",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M415.549 228.839L416.072 229.186L416.5 229.573L416.831 229.991L417.057 230.432L417.171 230.887V231.346L417.057 231.801L416.831 232.242L416.5 232.66L416.072 233.047L415.549 233.394",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M457.892 170.229L457.291 170.529L456.62 170.778L455.895 170.969L455.133 171.098L454.343 171.164H453.549L452.762 171.098L451.996 170.969L451.272 170.778L450.604 170.529L450.003 170.229",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M466.008 194.206L465.803 193.77L465.702 193.322L465.712 192.87L465.831 192.424L466.058 191.991L466.389 191.581L466.814 191.202L467.327 190.861L467.919 190.564L468.574 190.319L469.286 190.129L470.036 189.998L470.807 189.929L471.591 189.923L472.366 189.98L473.122 190.1",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M136.721 283.99L137.629 282.979L138.636 281.996L139.74 281.051L140.935 280.144L142.219 279.275L143.587 278.453L145.034 277.678L146.556 276.951L148.148 276.277L149.805 275.653L151.52 275.09L153.288 274.583L155.105 274.132L156.962 273.745L158.856 273.421L160.778 273.159L162.724 272.961",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M489.455 218.814L488.847 219.118L488.17 219.368L487.439 219.559L486.668 219.687L485.871 219.751L485.068 219.747L484.274 219.677L483.506 219.542L482.778 219.344L482.107 219.088L481.509 218.779L480.989 218.424L480.567 218.029L480.246 217.604",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M402.926 126.498L402.816 125.868L402.8 125.235L402.875 124.603L403.042 123.977L403.301 123.361L403.647 122.76L404.082 122.179L404.598 121.62L405.193 121.088L405.864 120.587L406.607 120.121",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M448.686 151.249L448.084 150.948L447.414 150.699L446.689 150.508L445.927 150.379L445.14 150.313H444.343L443.556 150.379L442.79 150.508L442.066 150.699L441.398 150.948L440.797 151.249",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M430.933 144.795L430.511 144.995L430.029 145.144L429.507 145.236L428.962 145.267L428.417 145.236L427.894 145.144L427.412 144.995L426.99 144.795",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.274 161.118L358.221 161.557L358.066 161.987L357.811 162.401L357.462 162.792L357.021 163.151L356.501 163.472L355.912 163.749L355.26 163.978L354.564 164.153L353.831 164.272L353.075 164.331H352.313L351.56 164.272L350.826 164.153L350.127 163.978L349.478 163.749L348.886 163.472L348.366 163.151L347.929 162.792L347.579 162.401L347.324 161.987L347.167 161.557L347.116 161.118L347.167 160.679L347.324 160.249L347.579 159.835L347.929 159.445L348.366 159.085L348.886 158.764L349.478 158.487L350.127 158.258L350.826 158.083L351.56 157.964L352.313 157.905H353.075L353.831 157.964L354.564 158.083L355.26 158.258L355.912 158.487L356.501 158.764L357.021 159.085L357.462 159.445L357.811 159.835L358.066 160.249L358.221 160.679L358.274 161.118Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M474.986 247.667L475.944 248.169L476.986 248.613L478.098 248.995L479.273 249.311L480.495 249.559L481.751 249.735L483.033 249.838L484.327 249.868L485.619 249.823L486.897 249.704L488.147 249.512L489.36 249.25L490.522 248.919L491.621 248.524L492.645 248.067L493.586 247.554L494.434 246.989L495.183 246.379L495.819 245.728L496.342 245.045L496.745 244.334L497.025 243.605L497.177 242.862",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M412.525 148.591L412.178 148.347L411.92 148.069L411.763 147.767L411.709 147.453L411.763 147.138L411.92 146.836L412.178 146.558L412.525 146.314",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.128 255.524L109.18 255.962L109.335 256.392L109.59 256.807L109.94 257.197L110.379 257.556L110.899 257.877L111.49 258.155L112.14 258.383L112.838 258.559L113.572 258.677L114.326 258.737H115.087L115.842 258.677L116.575 258.559L117.273 258.383L117.924 258.155L118.515 257.877L119.034 257.556L119.474 257.197L119.824 256.807L120.079 256.392L120.234 255.962L120.286 255.524L120.234 255.085L120.079 254.654L119.824 254.24L119.474 253.85L119.034 253.491L118.515 253.169L117.924 252.892L117.273 252.664L116.575 252.489L115.842 252.37L115.087 252.31H114.326L113.572 252.37L112.838 252.489L112.14 252.664L111.49 252.892L110.899 253.169L110.379 253.491L109.94 253.85L109.59 254.24L109.335 254.654L109.18 255.085L109.128 255.524Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2 180.098L387.677 179.751L387.246 179.364L386.915 178.946L386.691 178.505L386.578 178.05V177.591L386.691 177.136L386.915 176.695L387.246 176.277L387.677 175.89L388.2 175.543",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M458.487 495.955L457.183 495.665L455.92 495.322L454.704 494.922L453.545 494.475L452.449 493.977L451.419 493.432L450.462 492.843L449.583 492.217L448.793 491.552L448.087 490.856L447.473 490.132L446.957 489.382L446.541 488.614L446.223 487.83L446.009 487.033L445.902 486.23L445.896 485.423L445.996 484.617L446.201 483.82L446.51 483.033L446.919 482.262L447.426 481.512L448.031 480.784L448.727 480.085L449.511 479.421L450.383 478.791L451.331 478.199",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M391.154 147.262L392.723 146.286L394.197 145.263L395.573 144.195L396.848 143.086L398.017 141.939L399.078 140.757L400.026 139.543L400.861 138.303L401.579 137.037L402.177 135.752L402.653 134.45L403.008 133.135L403.241 131.81L403.349 130.481L403.333 129.149L403.191 127.821L402.927 126.499",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M439.497 465.651L440.483 465.27L441.528 464.946L442.624 464.685L443.758 464.483L444.92 464.351L446.101 464.281H447.289L448.47 464.344L449.632 464.477L450.769 464.675L451.865 464.937L452.913 465.258L453.899 465.639L454.819 466.07L455.656 466.555L456.412 467.084L457.074 467.651L457.634 468.256L458.091 468.889L458.437 469.544L458.67 470.215L458.787 470.895L458.79 471.582L458.677 472.262L458.447 472.936L458.103 473.591L457.653 474.224L457.096 474.829L456.437 475.399L455.688 475.928L454.85 476.413L453.934 476.847",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3496 262.333L56.8415 263.072L57.4314 263.787L58.1151 264.473L58.8892 265.126L59.7487 265.743L60.6885 266.319L61.7025 266.852L62.7853 267.338L63.9301 267.773L65.1297 268.158L66.3774 268.485L67.6652 268.756L68.9857 268.967L70.3308 269.121L71.6926 269.213L73.0622 269.244L74.4325 269.216L75.7943 269.125L77.1397 268.97L78.4605 268.759L79.7489 268.488L80.9973 268.161L82.1978 267.779L83.3436 267.345L84.4273 266.86L85.4426 266.328L86.3833 265.752L87.244 265.136",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M362.558 222.993L362.904 223.237L363.162 223.515L363.32 223.818L363.373 224.132L363.32 224.446L363.162 224.748L362.904 225.026L362.558 225.271",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M472.801 512.433L473.818 512.603L474.857 512.716L475.912 512.77H476.974L478.026 512.707L479.065 512.59L480.082 512.417L481.062 512.187L482.003 511.904L482.891 511.573L483.723 511.195L484.488 510.77L485.181 510.307L485.792 509.81L486.321 509.28L486.759 508.723L487.105 508.147L487.354 507.551L487.505 506.947L487.555 506.336",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M421.277 448.282L420.039 448.664L418.858 449.098L417.74 449.586L416.695 450.125L415.725 450.707L414.837 451.334L414.04 451.999L413.334 452.698L412.73 453.428L412.226 454.184L411.826 454.959L411.536 455.75L411.353 456.553L411.284 457.359L411.322 458.168L411.473 458.974L411.735 459.768L412.106 460.549L412.582 461.308L413.158 462.045L413.838 462.754L414.61 463.431L415.473 464.067L416.421 464.662L417.447 465.213L418.547 465.714L419.712 466.164L420.934 466.561L422.206 466.898L423.523 467.179L424.87 467.396L426.247 467.55L427.639 467.641L429.04 467.67L430.438 467.635L431.83 467.534L433.204 467.371L434.548 467.144L435.859 466.857L437.125 466.511L438.34 466.111L439.496 465.651",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M445.886 499.457L445.936 500.238L446.084 501.019L446.33 501.791L446.673 502.55L447.114 503.293L447.646 504.014L448.267 504.714L448.975 505.381L449.766 506.021L450.635 506.622L451.58 507.189L452.591 507.712L453.668 508.191L454.802 508.622L455.986 509.006L457.217 509.34L458.486 509.62",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M541.784 300.203L543.145 299.466L544.587 298.783L546.099 298.15L547.677 297.576L549.317 297.063L551.012 296.61L552.753 296.222L554.533 295.898L556.344 295.64L558.18 295.451",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M394.117 282.97L394.142 282.469L394.218 282.006L394.341 281.581",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.161 460.994L476.111 461.431L475.953 461.863L475.698 462.275L475.349 462.666L474.911 463.025L474.391 463.346L473.799 463.623L473.15 463.853L472.451 464.03L471.717 464.146L470.961 464.206H470.202L469.447 464.146L468.713 464.03L468.017 463.853L467.365 463.623L466.773 463.346L466.253 463.025L465.815 462.666L465.466 462.275L465.211 461.863L465.056 461.431L465.003 460.994L465.056 460.556L465.211 460.124L465.466 459.709L465.815 459.321L466.253 458.959L466.773 458.638L467.365 458.361L468.017 458.134L468.713 457.958L469.447 457.841L470.202 457.781H470.961L471.717 457.841L472.451 457.958L473.15 458.134L473.799 458.361L474.391 458.638L474.911 458.959L475.349 459.321L475.698 459.709L475.953 460.124L476.111 460.556L476.161 460.994Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M453.933 476.848L452.828 477.364L451.798 477.931L450.85 478.542L449.99 479.197L449.225 479.89L448.557 480.614L447.994 481.367L447.537 482.145L447.191 482.942L446.954 483.751L446.835 484.567L446.825 485.389L446.932 486.208L447.156 487.017L447.487 487.817L447.931 488.595L448.482 489.354L449.134 490.081L449.886 490.777L450.737 491.439L451.672 492.056L452.692 492.626L453.788 493.149L454.954 493.621L456.182 494.034L457.461 494.39L458.786 494.686",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M421.73 147.832L422.077 148.076L422.335 148.355L422.493 148.657L422.546 148.971L422.493 149.285L422.335 149.587L422.077 149.866L421.73 150.11",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M466.833 258.448L467.353 258.795L467.784 259.182L468.115 259.6L468.338 260.041L468.452 260.496V260.955L468.338 261.41L468.115 261.851L467.784 262.269L467.353 262.656L466.833 263.003",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M401.61 241.442L401.008 241.743L400.341 241.991L399.616 242.182L398.851 242.311L398.064 242.377H397.267L396.48 242.311L395.717 242.182L394.993 241.991L394.322 241.743L393.721 241.442",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M440.797 145.175L441.398 144.874L442.066 144.625L442.79 144.434L443.556 144.305L444.343 144.24H445.14L445.927 144.305L446.689 144.434L447.414 144.625L448.084 144.874L448.686 145.175",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M471.89 335.026L471.074 334.925L470.29 334.768L469.547 334.551L468.854 334.283L468.23 333.965",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M446.069 57.9629L447.174 57.4467L448.204 56.8808L449.152 56.2689L450.012 55.6151L450.777 54.9235L451.445 54.1985L452.009 53.4449L452.465 52.6676L452.812 51.8715L453.048 51.0618L453.168 50.2442L453.177 49.4231L453.07 48.6046L452.849 47.7937L452.516 46.9956L452.072 46.2159L451.52 45.4588L450.869 44.73L450.116 44.0337L449.266 43.3748L448.33 42.7573L447.31 42.1853L446.214 41.6625L445.049 41.1923L443.82 40.7779L442.542 40.4217L441.216 40.126",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.774 255.251L784.721 255.69L784.566 256.12L784.311 256.534L783.962 256.925L783.524 257.284L783.001 257.605L782.412 257.883L781.76 258.111L781.064 258.286L780.331 258.405L779.575 258.465H778.813L778.06 258.405L777.326 258.286L776.627 258.111L775.978 257.883L775.386 257.605L774.866 257.284L774.429 256.925L774.079 256.534L773.824 256.12L773.667 255.69L773.616 255.251L773.667 254.813L773.824 254.382L774.079 253.968L774.429 253.578L774.866 253.219L775.386 252.897L775.978 252.62L776.627 252.392L777.326 252.216L778.06 252.098L778.813 252.038H779.575L780.331 252.098L781.064 252.216L781.76 252.392L782.412 252.62L783.001 252.897L783.524 253.219L783.962 253.578L784.311 253.968L784.566 254.382L784.721 254.813L784.774 255.251Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M486.585 491.397L486.21 488.506L485.948 485.609L485.807 482.712L485.778 479.811L485.87 476.91L486.074 474.013L486.396 471.119L486.836 468.228L487.391 465.346L488.062 462.471",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.06 485.03L470.007 485.471L469.853 485.899L469.598 486.315L469.248 486.705L468.81 487.064L468.291 487.386L467.698 487.663L467.05 487.889L466.351 488.066L465.617 488.185L464.861 488.245H464.102L463.346 488.185L462.612 488.066L461.916 487.889L461.264 487.663L460.672 487.386L460.153 487.064L459.715 486.705L459.365 486.315L459.11 485.899L458.956 485.471L458.902 485.03L458.956 484.592L459.11 484.161L459.365 483.748L459.715 483.358L460.153 482.999L460.672 482.677L461.264 482.4L461.916 482.17L462.612 481.997L463.346 481.877L464.102 481.818H464.861L465.617 481.877L466.351 481.997L467.05 482.17L467.698 482.4L468.291 482.677L468.81 482.999L469.248 483.358L469.598 483.748L469.853 484.161L470.007 484.592L470.06 485.03Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M388.855 162.257L388.508 162.013L388.25 161.734L388.093 161.432L388.039 161.118L388.093 160.804L388.25 160.502L388.508 160.223L388.855 159.979",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M133.298 301.957L132.224 302.527L131.072 303.047L129.85 303.507L128.566 303.91L127.228 304.247L125.847 304.521L124.432 304.729L122.992 304.867L121.537 304.937H120.077L118.621 304.867L117.181 304.729L115.766 304.521L114.385 304.247L113.048 303.91L111.763 303.507L110.541 303.047L109.389 302.527L108.314 301.957",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M564.453 315.96L565.319 315.856L566.154 315.695L566.954 315.475L567.7 315.204L568.387 314.883L569.004 314.517L569.539 314.114L569.99 313.676L570.346 313.207L570.604 312.722L570.761 312.218L570.815 311.711",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M462.484 214.326L462.686 214.744L462.786 215.173V215.607L462.689 216.037L462.487 216.455L462.194 216.854L461.81 217.226L461.341 217.565L460.799 217.865L460.191 218.12L459.53 218.326L458.828 218.478L458.097 218.575L457.348 218.614L456.598 218.594L455.861 218.517L455.146 218.383L454.469 218.195L453.842 217.956L453.275 217.671",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.368 457.472L423.422 457.91L423.576 458.339L423.831 458.754L424.181 459.145L424.622 459.504L425.141 459.825L425.73 460.102L426.382 460.332L427.081 460.505L427.812 460.625L428.568 460.685H429.33L430.083 460.625L430.816 460.505L431.516 460.332L432.164 460.102L432.756 459.825L433.276 459.504L433.714 459.145L434.066 458.754L434.322 458.339L434.476 457.91L434.526 457.472L434.476 457.032L434.322 456.603L434.066 456.188L433.714 455.797L433.276 455.438L432.756 455.117L432.164 454.84L431.516 454.61L430.816 454.436L430.083 454.317L429.33 454.257H428.568L427.812 454.317L427.081 454.436L426.382 454.61L425.73 454.84L425.141 455.117L424.622 455.438L424.181 455.797L423.831 456.188L423.576 456.603L423.422 457.032L423.368 457.472Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M567.117 273.972L566.959 273.528L566.707 273.099L566.367 272.69L565.945 272.309L565.448 271.959L564.881 271.644L564.251 271.373L563.571 271.15L562.85 270.973L562.097 270.847L561.322 270.775L560.538 270.759L559.757 270.794",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M564.317 288.856L565.089 288.764L565.832 288.619L566.541 288.421L567.202 288.179L567.81 287.889L568.352 287.561L568.821 287.196L569.211 286.802L569.517 286.383L569.731 285.949L569.854 285.498L569.882 285.045L569.813 284.595",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M440.378 433.269L440.057 434.33L439.638 435.379L439.122 436.415L438.507 437.433L437.799 438.428L436.999 439.401L436.108 440.346L435.128 441.265L434.067 442.15L432.92 443.001L431.699 443.813L430.401 444.588L429.031 445.319L427.598 446.008L426.099 446.651L424.543 447.243L422.934 447.788L421.277 448.282",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M391.75 240.303L391.227 239.955L390.799 239.569L390.468 239.151L390.244 238.71L390.131 238.255V237.795L390.244 237.34L390.468 236.899L390.799 236.482L391.227 236.095L391.75 235.747",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M473.1 497.501L474.076 497.662L475.074 497.766L476.085 497.813L477.102 497.801L478.11 497.731L479.099 497.605L480.063 497.423L480.992 497.187L481.877 496.897L482.705 496.56L483.47 496.176L484.17 495.747L484.79 495.284L485.328 494.787L485.779 494.264L486.135 493.716L486.396 493.149L486.56 492.57L486.623 491.984L486.585 491.398",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M127.856 248.691L128.438 249.042",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M513.647 198.32L514.337 198.491L514.98 198.714L515.565 198.984L516.082 199.297L516.523 199.648L516.879 200.03L517.14 200.435L517.307 200.857L517.373 201.289L517.342 201.721L517.206 202.147L516.973 202.559L516.649 202.949L516.236 203.311L515.742 203.637",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9902 279.883L88.7332 279.363L89.5655 278.894L90.4782 278.475L91.4611 278.116L92.5039 277.817L93.5948 277.584L94.7223 277.414L95.874 277.316L97.037 277.288L98.1991 277.329L99.3477 277.439L100.47 277.615L101.554 277.861L102.587 278.173",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M458.787 509.869L457.53 509.592L456.314 509.258L455.146 508.874L454.031 508.44L452.976 507.955L451.99 507.429",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.509 261.333L390.562 261.771L390.717 262.202L390.972 262.616L391.321 263.006L391.762 263.365L392.282 263.686L392.871 263.964L393.523 264.193L394.222 264.368L394.953 264.486L395.708 264.546H396.47L397.223 264.486L397.957 264.368L398.656 264.193L399.305 263.964L399.897 263.686L400.417 263.365L400.854 263.006L401.207 262.616L401.462 262.202L401.617 261.771L401.667 261.333L401.617 260.894L401.462 260.464L401.207 260.049L400.854 259.659L400.417 259.3L399.897 258.978L399.305 258.701L398.656 258.473L397.957 258.298L397.223 258.179L396.47 258.119H395.708L394.953 258.179L394.222 258.298L393.523 258.473L392.871 258.701L392.282 258.978L391.762 259.3L391.321 259.659L390.972 260.049L390.717 260.464L390.562 260.894L390.509 261.333Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M412.446 57.3271L412.49 57.8843",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M335.684 233.809L334.912 233.902L334.169 234.047L333.461 234.244L332.799 234.488L332.191 234.776L331.65 235.105L331.18 235.469L330.79 235.863L330.488 236.282L330.27 236.718L330.147 237.166L330.119 237.62L330.188 238.072",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M427.649 157.322L427.126 156.975L426.695 156.588L426.364 156.17L426.141 155.729L426.027 155.274V154.815L426.141 154.36L426.364 153.919L426.695 153.501L427.126 153.114L427.649 152.767",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M418.443 193.005L417.841 193.306L417.17 193.554L416.446 193.745L415.684 193.874L414.897 193.94H414.1L413.312 193.874L412.547 193.745L411.823 193.554L411.155 193.306L410.554 193.005",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M398.536 203.528L398.02 203.756L397.456 203.941L396.851 204.079L396.218 204.166L395.573 204.202L394.921 204.186",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M811.267 270.633L812.013 270.114",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M794.112 262.422L793.498 262.951L792.978 263.512L792.556 264.1L792.235 264.71L792.021 265.335L791.917 265.968L791.92 266.605L792.03 267.239L792.251 267.863L792.578 268.473L793.003 269.058L793.529 269.619L794.15 270.145L794.855 270.633",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M454.923 476.375L455.672 475.852L456.324 475.285L456.869 474.684L457.3 474.051L457.612 473.396L457.804 472.725L457.874 472.048L457.817 471.368L457.641 470.697L457.338 470.038L456.919 469.405L456.387 468.798L455.748 468.228L455.008 467.699L454.176 467.22L453.26 466.792L452.271 466.423L451.219 466.118L450.12 465.875L448.98 465.702L447.818 465.601L446.643 465.57L445.468 465.607L444.306 465.721L443.173 465.903L442.077 466.152L441.034 466.467L440.055 466.842",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M430.332 444.626L431.623 443.816L432.829 442.963L433.951 442.075L434.98 441.152L435.922 440.195L436.763 439.209L437.509 438.195L438.152 437.159L438.694 436.107L439.128 435.036L439.459 433.953",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M439.497 480.838L438.344 481.295L437.131 481.695L435.865 482.041L434.558 482.328L433.217 482.554L431.847 482.718L430.461 482.819L429.063 482.854L427.665 482.828L426.276 482.737L424.903 482.583L423.555 482.369L422.241 482.091L420.969 481.754L419.747 481.361L418.582 480.914L417.483 480.416L416.456 479.868",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.611 237.038L478.662 237.477L478.819 237.907L479.074 238.321L479.424 238.712L479.862 239.071L480.381 239.392L480.973 239.67L481.622 239.898L482.321 240.073L483.055 240.192L483.808 240.252H484.57L485.326 240.192L486.06 240.073L486.756 239.898L487.407 239.67L487.996 239.392L488.516 239.071L488.957 238.712L489.306 238.321L489.562 237.907L489.716 237.477L489.769 237.038L489.716 236.6L489.562 236.169L489.306 235.755L488.957 235.365L488.516 235.005L487.996 234.684L487.407 234.407L486.756 234.178L486.06 234.003L485.326 233.885L484.57 233.825H483.808L483.055 233.885L482.321 234.003L481.622 234.178L480.973 234.407L480.381 234.684L479.862 235.005L479.424 235.365L479.074 235.755L478.819 236.169L478.662 236.6L478.611 237.038Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M421.466 217.071L421.101 217.333L420.836 217.633L420.685 217.958L420.653 218.294L420.745 218.627L420.952 218.941L421.271 219.224L421.683 219.461L422.171 219.645L422.716 219.766L423.292 219.818L423.875 219.801L424.439 219.713L424.958 219.561L425.412 219.349",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M340.245 279.203L339.495 279.237L338.739 279.225L337.993 279.159L337.265 279.045L336.566 278.885L335.902 278.677L335.284 278.428L334.721 278.138",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M849.404 281.329L849.71 281.943L849.908 282.573L849.997 283.209L849.975 283.848L849.842 284.484L849.603 285.108L849.26 285.716L848.812 286.302L848.264 286.856L847.625 287.379L846.901 287.86L846.098 288.301L845.219 288.692L844.28 289.032L843.288 289.315L842.252 289.539L841.182 289.703L840.089 289.807L838.983 289.848L837.878 289.823",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M410.353 471.897L410.403 472.687L410.554 473.472L410.806 474.249L411.156 475.015L411.6 475.764L412.141 476.489L412.771 477.191L413.492 477.865L414.296 478.507L415.177 479.112L416.135 479.676L417.161 480.202L418.251 480.677L419.401 481.109L420.604 481.49L421.848 481.82L423.133 482.094L424.449 482.315L425.791 482.476L427.148 482.583L428.515 482.63L429.885 482.62L431.252 482.551L432.603 482.422L433.935 482.239L435.242 482L436.511 481.704L437.742 481.357L438.923 480.958L440.054 480.507",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M343.398 235.151L343.111 235.714L342.926 236.291L342.844 236.876L342.869 237.463L342.995 238.045L343.228 238.616L343.559 239.171L343.987 239.703L344.51 240.207L345.118 240.677L345.807 241.108L346.569 241.496L347.398 241.837L348.283 242.126L349.215 242.361L350.182 242.54L351.177 242.661L352.188 242.721H353.205L354.216 242.661L355.211 242.54L356.178 242.361L357.11 242.126L357.995 241.837L358.82 241.496L359.586 241.108L360.272 240.677L360.883 240.207L361.403 239.703L361.834 239.171L362.165 238.616L362.395 238.045L362.524 237.463L362.549 236.876L362.467 236.291L362.281 235.714L361.995 235.151",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M450.31 233.422L449.589 233.418L448.874 233.36L448.178 233.25L447.514 233.089L446.89 232.88L446.32 232.625L445.81 232.331L445.369 232.001L445.007 231.641L444.727 231.257L444.538 230.855L444.437 230.443L444.431 230.026",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M401.349 167.951L401.95 167.65L402.621 167.402L403.342 167.21L404.107 167.081L404.895 167.016H405.692L406.479 167.081L407.244 167.21L407.965 167.402L408.636 167.65L409.238 167.951",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M741.861 279.911L743.713 279.782L745.574 279.713L747.442 279.704L749.303 279.751L751.161 279.858L753.004 280.022L754.83 280.242L756.632 280.519L758.405 280.853L760.146 281.244L761.844 281.688L763.5 282.182L765.11 282.73L766.662 283.325L768.158 283.968L769.591 284.658L770.955 285.391L772.252 286.169",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M483.546 99.7379L482.453 100.318L481.279 100.843L480.035 101.309L478.725 101.713",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M380.966 205.531L381.388 205.331L381.873 205.182L382.396 205.091L382.94 205.059L383.482 205.091L384.005 205.182L384.49 205.331L384.912 205.531",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M383.595 172.126L383.173 172.327L382.691 172.476L382.169 172.567L381.624 172.598L381.079 172.567L380.556 172.476L380.074 172.327L379.652 172.126",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M483.628 511.271L482.781 511.709L481.852 512.09L480.856 512.408L479.808 512.663L478.715 512.846L477.594 512.959L476.457 513L475.32 512.965L474.196 512.861L473.1 512.685",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M497.177 238.307L497.051 238.964L496.821 239.612L496.496 240.246L496.077 240.861L495.564 241.453L494.963 242.016L494.279 242.546L493.517 243.04L492.682 243.493L491.782 243.902L490.824 244.264L489.813 244.575L488.762 244.834L487.672 245.039L486.554 245.188L485.42 245.279L484.277 245.313L483.134 245.288L481.997 245.206L480.876 245.065L479.783 244.869L478.725 244.618L477.707 244.314L476.74 243.96L475.83 243.558L474.986 243.112",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M542.441 299.825L543.758 299.11L545.153 298.446L546.617 297.838L548.148 297.281L549.735 296.783L551.373 296.345L553.058 295.967L554.781 295.655L556.535 295.407L558.314 295.221",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M354.404 154.209L353.292 154.148L352.174 154.146L351.059 154.203L349.96 154.32L348.883 154.495L347.841 154.727L346.839 155.013L345.888 155.351L344.994 155.739L344.165 156.173L343.409 156.649L342.735 157.163L342.143 157.712L341.646 158.289L341.24 158.891L340.931 159.511L340.726 160.145L340.622 160.788L340.619 161.433L340.723 162.076L340.928 162.711L341.23 163.332L341.636 163.934L342.134 164.511L342.72 165.06L343.394 165.576L344.146 166.053",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M513.765 182.748L514.306 183.113L514.75 183.521L515.084 183.962L515.301 184.428L515.393 184.906L515.361 185.388L515.207 185.861L514.93 186.315L514.539 186.741L514.045 187.128L513.456 187.469L512.782 187.754L512.045 187.979L511.258 188.138L510.439 188.227L509.604 188.244L508.776 188.189L507.97 188.064",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M440.187 209.355L439.006 208.62L437.922 207.836L436.943 207.007L436.074 206.139L435.321 205.236L434.685 204.302L434.175 203.344L433.787 202.367",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M483.731 454.159L484.711 454.77L485.605 455.425L486.408 456.115L487.117 456.843L487.728 457.595L488.235 458.376L488.635 459.176L488.925 459.992L489.107 460.817L489.177 461.648L489.136 462.48L488.981 463.308",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M532.449 274.466L532.814 274.205L533.079 273.905L533.23 273.581L533.262 273.244L533.17 272.91L532.962 272.599L532.644 272.315L532.232 272.076L531.74 271.893L531.199 271.773L530.622 271.72L530.04 271.739L529.476 271.824L528.956 271.978L528.503 272.189",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M375.706 169.849L375.36 169.605L375.102 169.327L374.944 169.024L374.891 168.71L374.944 168.396L375.102 168.094L375.36 167.815L375.706 167.571",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M482.497 453.463L481.077 452.669L479.738 451.831L478.485 450.95L477.323 450.027L476.252 449.069L475.279 448.074L474.407 447.054L473.638 446.002L472.974 444.928L472.419 443.835L471.972 442.724L471.638 441.599L471.415 440.465L471.308 439.329L471.311 438.188L471.427 437.048L471.657 435.915",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M488.982 476.974L489.13 476.199L489.178 475.418",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M332.886 248.695L333.046 249.138L333.295 249.567L333.635 249.976L334.057 250.358L334.555 250.707L335.122 251.02L335.752 251.291L336.432 251.516L337.153 251.693L337.906 251.818L338.681 251.89L339.465 251.907L340.246 251.87",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M509.172 295.498L509.773 295.196L510.444 294.947L511.169 294.758L511.931 294.625L512.721 294.562H513.515L514.305 294.625L515.067 294.758L515.792 294.947L516.463 295.196L517.064 295.498",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M434.88 140.24L435.226 140.484L435.485 140.763L435.642 141.065L435.696 141.379L435.642 141.693L435.485 141.995L435.226 142.274L434.88 142.518",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M793.366 261.341L794.175 260.657L794.887 259.937L795.495 259.186L795.993 258.409L796.383 257.611L796.657 256.798L796.818 255.974L796.862 255.146L796.786 254.318L796.597 253.497L796.295 252.687L795.876 251.894L795.35 251.123L794.717 250.379L793.98 249.668L793.146 248.994L792.22 248.36L791.209 247.772L790.116 247.234L788.954 246.749L787.726 246.319L786.441 245.949L785.108 245.64L783.738 245.394L782.337 245.214L780.917 245.1L779.481 245.053L778.048 245.073L776.621 245.16L775.21 245.314L773.824 245.534L772.476 245.818L771.173 246.164L769.919 246.57L768.732 247.033L767.611 247.551L766.565 248.12L765.605 248.735L764.732 249.394L763.957 250.091L763.28 250.822",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M497.177 242.862L497.391 241.49L497.706 240.125L498.125 238.769L498.648 237.425L499.268 236.095L499.989 234.782L500.808 233.489L501.724 232.217L502.735 230.97L503.838 229.749L505.034 228.556L506.316 227.396L507.686 226.268L509.138 225.176L510.672 224.121L512.284 223.105L513.972 222.132L515.73 221.201L517.556 220.315L519.449 219.476L521.402 218.686L523.414 217.945L525.477 217.255L527.593 216.618L529.754 216.035L531.955 215.506L534.197 215.033L536.471 214.617L538.773 214.258L541.101 213.957L543.45 213.715L545.815 213.533L548.19 213.409",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M472.577 436.753L472.366 437.789L472.25 438.828L472.228 439.87L472.306 440.913L472.483 441.949L472.753 442.982L473.122 444.002L473.585 445.01L474.142 445.999L474.788 446.972L475.528 447.923L476.353 448.852L477.263 449.753L478.255 450.622L479.329 451.46L480.482 452.263L481.704 453.031",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M548.127 213.633L545.809 213.752L543.5 213.927L541.208 214.157L538.934 214.442L536.682 214.782L534.458 215.175L532.263 215.622L530.103 216.121L527.98 216.672L525.899 217.274L523.864 217.925L521.877 218.624L519.943 219.371L518.063 220.164L516.243 221.001L514.485 221.881L512.791 222.803",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M472.75 308.933L472.296 309.147L471.777 309.299L471.213 309.387L470.63 309.403L470.054 309.352L469.509 309.229L469.021 309.047L468.608 308.811L468.29 308.527L468.083 308.212L467.991 307.881L468.023 307.544L468.174 307.22L468.438 306.918L468.804 306.656",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M431.592 180.857L432.115 181.205L432.543 181.591L432.874 182.009L433.097 182.45L433.211 182.905V183.365L433.097 183.819L432.874 184.26L432.543 184.679L432.115 185.065L431.592 185.412",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M340.532 273.128C340.532 273.286 340.403 273.415 340.244 273.415C340.086 273.415 339.957 273.286 339.957 273.128C339.957 272.969 340.086 272.84 340.244 272.84C340.403 272.84 340.532 272.969 340.532 273.128Z",
    stroke: "#50226D"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M474.333 317.512L474.383 318.089L474.535 318.659L474.783 319.216L475.13 319.758L475.571 320.274L476.1 320.766L476.711 321.219L477.397 321.638L478.156 322.013L478.975 322.344L479.848 322.624L480.764 322.851L481.718 323.024L482.695 323.137L483.69 323.197H484.688L485.68 323.137L486.66 323.024L487.611 322.851L488.53 322.624L489.403 322.344L490.221 322.013L490.977 321.638L491.667 321.219L492.278 320.766L492.807 320.274L493.245 319.758L493.591 319.216L493.843 318.659L493.994 318.089L494.045 317.512",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M837.959 288.528L838.973 288.55L839.984 288.516L840.985 288.421L841.968 288.27L842.916 288.062L843.826 287.804L844.689 287.492L845.492 287.133L846.229 286.73L846.894 286.289L847.479 285.81L847.98 285.3L848.39 284.765L848.708 284.207L848.925 283.634L849.045 283.051L849.067 282.466L848.985 281.883L848.802 281.307L848.525 280.743",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M537.449 281.071L537.5 281.647L537.651 282.217L537.903 282.774L538.249 283.316L538.687 283.832L539.216 284.324L539.827 284.777L540.517 285.196L541.273 285.571L542.091 285.902L542.967 286.182L543.883 286.409L544.834 286.582L545.814 286.695L546.806 286.755H547.804L548.799 286.695L549.776 286.582L550.73 286.409L551.646 286.182L552.519 285.902L553.338 285.571L554.097 285.196L554.783 284.777L555.394 284.324L555.923 283.832L556.364 283.316L556.711 282.774L556.959 282.217L557.111 281.647L557.161 281.071",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M457.308 326.775L457.355 327.197L457.497 327.609L457.733 328.009L458.054 328.387L458.46 328.737L458.942 329.055",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M787.856 289.382L792.836 288.994L797.827 288.673L802.832 288.421L807.845 288.235L812.865 288.116L817.885 288.062L822.912 288.078L827.932 288.163L832.949 288.311L837.959 288.528",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M779.715 279.288L779.765 279.729L779.923 280.157L780.178 280.573L780.527 280.963L780.965 281.322L781.485 281.644L782.077 281.921L782.726 282.148L783.425 282.324L784.159 282.444L784.914 282.503H785.673L786.429 282.444L787.163 282.324L787.859 282.148L788.511 281.921L789.103 281.644L789.623 281.322L790.06 280.963L790.41 280.573L790.665 280.157L790.819 279.729L790.873 279.288L790.819 278.85L790.665 278.419L790.41 278.006L790.06 277.616L789.623 277.257L789.103 276.935L788.511 276.658L787.859 276.428L787.163 276.255L786.429 276.135L785.673 276.076H784.914L784.159 276.135L783.425 276.255L782.726 276.428L782.077 276.658L781.485 276.935L780.965 277.257L780.527 277.616L780.178 278.006L779.923 278.419L779.765 278.85L779.715 279.288Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2432 265.136L87.9974 264.608L88.8377 264.124L89.756 263.691L90.7433 263.311L91.7905 262.989L92.8874 262.729L94.0231 262.531L95.1867 262.399L96.3674 262.333L97.5538 262.334L98.7342 262.402L99.8972 262.537L101.032 262.737L102.127 263L103.172 263.324L104.157 263.706L105.073 264.141L105.91 264.626L106.661 265.156L107.318 265.726L107.875 266.331L108.327 266.964L108.67 267.62L108.899 268.293L109.013 268.974L109.011 269.657L108.893 270.34L108.659 271.011L108.313 271.666L107.857 272.299L107.296 272.901L106.635 273.471",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M493.488 312.958L493.437 313.519L493.283 314.073L493.031 314.618L492.681 315.141L492.24 315.642L491.711 316.114L491.097 316.552L490.411 316.949L489.655 317.301L488.836 317.607L487.97 317.862L487.063 318.064L486.121 318.208L485.161 318.297L484.187 318.328L483.218 318.297L482.254 318.208L481.315 318.064L480.405 317.862L479.539 317.607L478.723 317.301L477.968 316.949L477.278 316.552L476.667 316.114L476.135 315.642L475.694 315.141L475.344 314.618L475.092 314.073L474.941 313.519L474.891 312.958",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M488.061 462.471L488.203 461.712L488.247 460.946L488.19 460.181L488.036 459.419L487.781 458.669L487.431 457.929L486.987 457.208L486.449 456.509L485.822 455.835L485.107 455.189L484.313 454.575L483.441 453.999L482.496 453.463",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M475.64 241.973L476.531 242.439L477.498 242.851L478.531 243.206L479.62 243.5L480.754 243.73L481.923 243.893L483.113 243.989L484.316 244.017L485.516 243.975L486.703 243.864L487.865 243.687L488.99 243.443L490.067 243.136L491.087 242.768L492.038 242.345L492.914 241.868L493.701 241.344L494.394 240.777L494.986 240.173L495.474 239.538L495.849 238.879L496.107 238.201L496.249 237.512",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M548.189 208.854L545.814 208.978L543.449 209.16L541.1 209.402L538.772 209.703L536.47 210.062L534.196 210.478L531.954 210.951L529.753 211.48L527.592 212.063L525.476 212.7L523.413 213.39L521.401 214.131L519.448 214.921L517.555 215.76L515.729 216.646L513.971 217.576L512.283 218.55L510.671 219.566L509.137 220.62L507.685 221.713L506.315 222.84L505.033 224.001L503.837 225.193L502.734 226.414L501.723 227.662L500.807 228.934L499.988 230.227L499.267 231.54L498.647 232.87L498.124 234.214L497.705 235.57L497.39 236.935L497.176 238.306",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 221.247L428.331 221.509L428.066 221.809L427.915 222.134L427.884 222.47L427.975 222.803L428.186 223.117L428.504 223.399L428.914 223.637L429.405 223.821L429.95 223.941L430.523 223.994L431.106 223.976L431.669 223.889L432.189 223.736L432.642 223.525",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M508.251 282.362L508.774 282.711L509.202 283.096L509.533 283.514L509.756 283.955L509.87 284.412V284.869L509.756 285.325L509.533 285.766L509.202 286.185L508.774 286.569L508.251 286.919",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M329.186 242.842L329.208 243.154L329.264 243.464",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M494.312 294.966L493.916 295.174L493.487 295.359",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.578 292.459L455.525 292.9L455.37 293.328L455.115 293.744L454.766 294.134L454.328 294.493L453.808 294.814L453.216 295.092L452.567 295.318L451.868 295.495L451.134 295.614L450.378 295.674H449.619L448.864 295.614L448.13 295.495L447.434 295.318L446.782 295.092L446.19 294.814L445.67 294.493L445.232 294.134L444.883 293.744L444.628 293.328L444.473 292.9L444.42 292.459L444.473 292.021L444.628 291.59L444.883 291.177L445.232 290.786L445.67 290.427L446.19 290.106L446.782 289.829L447.434 289.599L448.13 289.426L448.864 289.306L449.619 289.246H450.378L451.134 289.306L451.868 289.426L452.567 289.599L453.216 289.829L453.808 290.106L454.328 290.427L454.766 290.786L455.115 291.177L455.37 291.59L455.525 292.021L455.578 292.459Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M556.508 196.042L557.377 196.596L558.149 197.197L558.81 197.839L559.358 198.516L559.787 199.222L560.092 199.948L560.272 200.688L560.322 201.435L560.243 202.181L560.039 202.919L559.705 203.642L559.251 204.341L558.678 205.012L557.995 205.646L557.201 206.238L556.313 206.781L555.336 207.271L554.278 207.702L553.151 208.071L551.967 208.373L550.738 208.605L549.472 208.766L548.188 208.854",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.334 261.333L498.384 261.771L498.542 262.202L498.794 262.616L499.147 263.006L499.584 263.365L500.104 263.687L500.696 263.964L501.345 264.193L502.044 264.368L502.778 264.486L503.53 264.546H504.293L505.048 264.486L505.779 264.368L506.478 264.193L507.13 263.964L507.719 263.687L508.239 263.365L508.68 263.006L509.029 262.616L509.284 262.202L509.439 261.771L509.492 261.333L509.439 260.894L509.284 260.464L509.029 260.049L508.68 259.659L508.239 259.3L507.719 258.979L507.13 258.701L506.478 258.473L505.779 258.298L505.048 258.179L504.293 258.119H503.53L502.778 258.179L502.044 258.298L501.345 258.473L500.696 258.701L500.104 258.979L499.584 259.3L499.147 259.659L498.794 260.049L498.542 260.464L498.384 260.894L498.334 261.333Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M403.845 125.663L404.097 126.886L404.242 128.115L404.286 129.346L404.223 130.576L404.056 131.804L403.788 133.025L403.417 134.238L402.941 135.438L402.368 136.624L401.694 137.792L400.919 138.94L400.053 140.064L399.089 141.163L398.034 142.233L396.891 143.273L395.663 144.279L394.35 145.249L392.954 146.181L391.484 147.072L389.94 147.922L388.328 148.726L386.646 149.484L384.905 150.194L383.103 150.854L381.248 151.463L379.346 152.019L377.4 152.52L375.409 152.966L373.388 153.355L371.334 153.687L369.256 153.961L367.155 154.175L365.039 154.331L362.913 154.426L360.781 154.462L358.649 154.438L356.523 154.353L354.403 154.209",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M471.304 301.419L471.669 301.158L471.933 300.858L472.085 300.531L472.116 300.197L472.025 299.863L471.814 299.548L471.499 299.268L471.086 299.029L470.595 298.846L470.05 298.723L469.477 298.673L468.894 298.688L468.331 298.777L467.811 298.928L467.357 299.142",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M465.514 304.76L465.061 304.971L464.544 305.123L463.981 305.211L463.398 305.23L462.822 305.176L462.277 305.056L461.789 304.871L461.376 304.634L461.058 304.351L460.85 304.036L460.759 303.705L460.787 303.368L460.938 303.044L461.203 302.742L461.571 302.48",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M420.019 271.811L420.385 271.547L420.649 271.248L420.8 270.923L420.832 270.586L420.741 270.255L420.533 269.941L420.215 269.657L419.802 269.421L419.314 269.235L418.769 269.115L418.193 269.062L417.61 269.081L417.046 269.169L416.527 269.32L416.073 269.531",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M410.288 272.873L409.923 273.134L409.658 273.433L409.507 273.761L409.476 274.094L409.567 274.428L409.775 274.743L410.093 275.024L410.505 275.263L410.994 275.446L411.538 275.568L412.115 275.619L412.697 275.603L413.261 275.515L413.781 275.361L414.234 275.15",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M430.013 284.261L429.559 284.472L429.039 284.626L428.476 284.711L427.893 284.73L427.32 284.677L426.775 284.557L426.284 284.374L425.871 284.135L425.556 283.855L425.345 283.54L425.254 283.206L425.285 282.869L425.437 282.544L425.701 282.245L426.066 281.984",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M558.313 290.667L556.694 290.831L555.098 291.051L553.523 291.322L551.98 291.646L550.471 292.021L549.004 292.446L547.583 292.922L546.21 293.441L544.894 294.008L543.634 294.619L542.44 295.268",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M431.854 278.642L432.308 278.431L432.828 278.277L433.388 278.192L433.971 278.173L434.547 278.227L435.092 278.346L435.58 278.529L435.993 278.768L436.311 279.052L436.519 279.364L436.61 279.697L436.582 280.034L436.43 280.359L436.166 280.658L435.797 280.919",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M367.552 248.198L367.186 248.46L366.922 248.76L366.771 249.085L366.739 249.422L366.831 249.754L367.042 250.069L367.357 250.351L367.769 250.589L368.26 250.772L368.802 250.893L369.378 250.946L369.961 250.928L370.525 250.841L371.044 250.688L371.498 250.476",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M380.57 249.034L381.024 248.822L381.543 248.669L382.107 248.582L382.69 248.564L383.263 248.617L383.808 248.738L384.299 248.921L384.712 249.159L385.027 249.441L385.238 249.756L385.329 250.088L385.297 250.425L385.146 250.75L384.882 251.05L384.516 251.311",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M499.489 329.184L499.776 328.249L500.154 327.326L500.626 326.419L501.187 325.528L501.839 324.655L502.576 323.808L503.394 322.989L504.298 322.196L505.278 321.437L506.336 320.709L507.463 320.019",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M374.786 252.374L374.418 252.636L374.153 252.936L374.002 253.261L373.974 253.597L374.065 253.93L374.273 254.244L374.591 254.527L375.003 254.765L375.492 254.948L376.036 255.069L376.613 255.121L377.195 255.103L377.759 255.017L378.279 254.864L378.729 254.652",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M373.34 244.858L373.79 244.646L374.31 244.494L374.874 244.406L375.456 244.389L376.033 244.441L376.577 244.562L377.066 244.745L377.478 244.984L377.796 245.266L378.004 245.58L378.095 245.913L378.067 246.249L377.916 246.574L377.651 246.874L377.283 247.136",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M379.652 208.568L379.305 208.324L379.047 208.046L378.887 207.744L378.833 207.43L378.887 207.115L379.047 206.813L379.305 206.535L379.652 206.291",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M412.489 57.8845L412.757 59.8484L412.971 61.8149",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M498.392 281.225L498.993 280.922L499.661 280.674L500.385 280.485L501.15 280.356L501.938 280.289H502.735L503.522 280.356L504.284 280.485L505.008 280.674L505.679 280.922L506.281 281.225",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M459.814 313.311L460.945 314.01L461.984 314.757L462.932 315.544L463.776 316.366L464.52 317.223L465.156 318.108L465.679 319.015L466.091 319.944L466.384 320.885L466.564 321.837L466.623 322.794L466.564 323.751L466.387 324.702",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M468.144 244.023L467.694 244.235L467.174 244.388L466.61 244.475L466.028 244.493L465.452 244.44L464.907 244.319L464.419 244.136L464.006 243.898L463.688 243.615L463.48 243.301L463.389 242.969L463.417 242.632L463.568 242.307L463.833 242.007L464.201 241.745",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M525.214 270.29L525.583 270.029L525.847 269.729L525.999 269.405L526.027 269.068L525.936 268.734L525.728 268.422L525.41 268.139L524.997 267.901L524.509 267.718L523.964 267.597L523.388 267.544L522.805 267.562L522.245 267.649L521.725 267.802L521.271 268.014",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M377.027 224.891L377.078 225.467L377.229 226.037L377.478 226.595L377.824 227.135L378.265 227.653L378.794 228.142L379.405 228.598L380.092 229.016L380.851 229.391L381.669 229.72L382.542 230L383.458 230.227L384.413 230.4L385.389 230.516L386.384 230.574H387.382L388.374 230.516L389.354 230.4L390.305 230.227L391.221 230L392.097 229.72L392.916 229.391L393.672 229.016L394.361 228.598L394.972 228.142L395.498 227.653L395.939 227.135L396.286 226.595L396.538 226.037L396.689 225.467L396.739 224.891",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M449.271 479.613L448.253 479.512L447.227 479.462H446.197L445.17 479.512L444.153 479.616L443.158 479.764L442.185 479.966L441.246 480.211L440.349 480.501L439.495 480.838",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.35 275.767L821.4 276.205L821.554 276.636L821.809 277.052L822.162 277.439L822.6 277.798L823.119 278.123L823.712 278.4L824.36 278.627L825.06 278.803L825.793 278.919L826.546 278.979H827.308L828.064 278.919L828.795 278.803L829.494 278.627L830.146 278.4L830.735 278.123L831.254 277.798L831.695 277.439L832.045 277.052L832.3 276.636L832.454 276.205L832.508 275.767L832.454 275.329L832.3 274.898L832.045 274.485L831.695 274.095L831.254 273.736L830.735 273.414L830.146 273.137L829.494 272.907L828.795 272.731L828.064 272.614L827.308 272.555H826.546L825.793 272.614L825.06 272.731L824.36 272.907L823.712 273.137L823.119 273.414L822.6 273.736L822.162 274.095L821.809 274.485L821.554 274.898L821.4 275.329L821.35 275.767Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M526.662 277.808L526.208 278.019L525.689 278.173L525.125 278.258L524.542 278.277L523.966 278.223L523.421 278.104L522.933 277.921L522.521 277.682L522.202 277.398L521.995 277.087L521.903 276.753L521.932 276.416L522.083 276.091L522.347 275.792L522.716 275.531",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M465.392 330.548L465.445 331.058L465.603 331.559L465.861 332.047L466.217 332.513L466.667 332.951L467.202 333.357L467.82 333.722L468.506 334.044L469.253 334.315L470.053 334.532L470.887 334.692L471.753 334.796",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M459.814 334.57L460.98 335.291L462.047 336.063L463.014 336.878L463.877 337.732",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M493.487 311.072L493.774 311.636L493.96 312.212L494.041 312.798L494.016 313.384L493.887 313.966L493.657 314.536L493.326 315.091L492.895 315.623L492.375 316.127L491.764 316.596L491.078 317.027L490.313 317.418L489.487 317.758L488.602 318.048L487.67 318.281L486.703 318.46L485.708 318.58L484.697 318.64H483.68L482.669 318.58L481.674 318.46L480.707 318.281L479.775 318.048L478.89 317.758L478.062 317.418L477.299 317.027L476.61 316.596L476.002 316.127L475.479 315.623L475.051 315.091L474.72 314.536L474.487 313.966L474.358 313.384L474.336 312.798L474.418 312.212L474.604 311.636L474.89 311.072",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M162.857 274.252L161.069 274.432L159.3 274.668L157.557 274.958L155.842 275.304L154.163 275.701L152.524 276.151L150.93 276.652L149.384 277.203L147.893 277.798L146.46 278.441L145.089 279.13L143.785 279.858L142.551 280.626L141.392 281.433L140.309 282.273L139.307 283.146L138.389 284.05L137.557 284.982",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M447.106 251.615L447.708 251.314L448.379 251.066L449.103 250.875L449.865 250.745L450.653 250.68H451.449L452.237 250.745L453.002 250.875L453.726 251.066L454.394 251.314L454.996 251.615",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M416.876 96.172L418.265 96.9474L419.572 97.7678L420.797 98.6304L421.934 99.5323L422.976 100.471L423.924 101.442L424.775 102.443L425.524 103.472L426.167 104.523",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M843.65 272.479L843.158 271.742L842.569 271.027L841.886 270.34L841.111 269.685L840.252 269.071L839.313 268.495L838.299 267.961L837.216 267.475L836.069 267.04L834.869 266.656L833.622 266.328L832.334 266.057L831.015 265.844L829.67 265.691L828.309 265.598L826.939 265.567L825.569 265.597L824.206 265.689L822.861 265.841L821.541 266.053L820.25 266.323L819.003 266.651L817.803 267.033L816.657 267.468L815.573 267.953L814.559 268.485L813.618 269.062L812.758 269.676",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M433.168 264.218L432.648 263.87L432.216 263.484L431.886 263.066L431.662 262.625L431.549 262.17V261.71L431.662 261.255L431.886 260.814L432.216 260.397L432.648 260.01L433.168 259.663",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M376.603 276.378L377.072 276.372L377.532 276.318L377.969 276.22L378.372 276.085L378.728 275.909",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M452.892 271.049L452.291 271.352L451.62 271.6L450.899 271.792L450.133 271.922L449.346 271.985H448.549L447.762 271.922L446.996 271.792L446.275 271.6L445.604 271.352L445.003 271.049",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M340.243 251.87L341.774 251.774L343.314 251.736L344.851 251.757L346.384 251.836L347.905 251.975L349.408 252.171L350.885 252.423L352.327 252.732L353.735 253.096L355.095 253.512L356.402 253.979L357.656 254.495L358.849 255.059L359.974 255.666",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M763.278 250.823L762.371 251.835L761.364 252.816L760.261 253.762L759.064 254.67L757.78 255.536L756.413 256.359L754.964 257.135L753.443 257.861L751.852 258.537L750.196 259.158L748.479 259.723L746.713 260.231L744.896 260.679L743.037 261.066L741.145 261.391L739.22 261.653L737.277 261.851",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M343.396 233.131L341.821 233.29",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M542.44 315.009L543.757 314.294L545.152 313.632L546.616 313.021L548.147 312.464L549.734 311.966L551.372 311.529L553.057 311.154L554.78 310.839L556.534 310.59L558.313 310.404",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M487.028 488.182L487.353 485.37L487.784 482.567L488.329 479.767L488.981 476.974",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M388.854 202.495L388.098 202.108L387.266 201.776L386.372 201.505L385.427 201.298L384.445 201.159L383.443 201.088H382.432L381.431 201.159L380.448 201.298L379.503 201.505L378.609 201.776L377.777 202.108L377.021 202.495",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M394.919 204.186L393.952 204.094L393.004 203.95L392.085 203.754L391.203 203.508L390.365 203.214L389.581 202.875L388.854 202.495",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M418.298 96.9659L417.504 96.5348",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M498.592 349.429L498.435 349.882L498.192 350.32L497.874 350.742",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M559.756 270.794L558.71 270.866L557.659 270.914L556.604 270.929",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M490.288 330.51L491.072 330.548L491.856 330.532L492.634 330.46L493.39 330.337L494.115 330.16L494.795 329.934L495.428 329.663L495.995 329.351L496.495 329.001L496.917 328.617L497.258 328.208L497.51 327.78L497.67 327.335",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M405.687 227.7L406.288 227.399L406.956 227.151L407.68 226.96L408.445 226.83L409.233 226.765H410.029L410.817 226.83L411.579 226.96L412.303 227.151L412.974 227.399L413.576 227.7",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M340.244 257.944L339.494 257.981L338.738 257.967L337.992 257.903L337.264 257.789L336.565 257.628L335.901 257.421L335.283 257.171L334.72 256.881",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M106.635 273.471L105.825 274.154L105.114 274.876L104.507 275.625L104.008 276.403L103.619 277.2L103.344 278.016L103.184 278.838L103.141 279.666L103.214 280.494L103.403 281.316L103.707 282.125L104.124 282.919L104.651 283.691L105.285 284.434L106.021 285.146L106.855 285.82L107.781 286.453L108.793 287.042L109.885 287.577L111.048 288.065L112.276 288.493L113.56 288.865L114.892 289.174L116.263 289.419L117.664 289.599L119.086 289.712L120.519 289.759L121.954 289.741L123.381 289.652L124.792 289.498L126.176 289.278L127.525 288.994L128.829 288.648L130.08 288.241L131.271 287.779L132.391 287.262L133.436 286.692L134.397 286.078L135.269 285.42L136.045 284.721L136.72 283.99",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.384 279.562L126.332 280L126.177 280.431L125.922 280.844L125.572 281.234L125.133 281.593L124.613 281.914L124.022 282.192L123.372 282.421L122.673 282.598L121.94 282.714L121.186 282.774H120.425L119.67 282.714L118.937 282.598L118.239 282.421L117.588 282.192L116.997 281.914L116.478 281.593L116.038 281.234L115.688 280.844L115.433 280.431L115.279 280L115.227 279.562L115.279 279.124L115.433 278.693L115.688 278.277L116.038 277.886L116.478 277.527L116.997 277.206L117.588 276.929L118.239 276.702L118.937 276.526L119.67 276.406L120.425 276.346H121.186L121.94 276.406L122.673 276.526L123.372 276.702L124.022 276.929L124.613 277.206L125.133 277.527L125.572 277.886L125.922 278.277L126.177 278.693L126.332 279.124L126.384 279.562Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M388.854 207.809L389.203 208.053L389.458 208.332L389.619 208.634L389.672 208.948L389.619 209.262L389.458 209.564L389.203 209.843L388.854 210.087",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0416 246.283L61.0272 246.262L60.0141 246.298L59.0123 246.393L58.0316 246.544L57.0817 246.75L56.1722 247.01L55.3115 247.321L54.5084 247.679L53.7708 248.082L53.1057 248.524L52.5202 249.003L52.0198 249.513L51.6091 250.049L51.2926 250.605L51.0734 251.178L50.9531 251.76L50.9336 252.346L51.0148 252.93L51.1956 253.506L51.475 254.07",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M496.492 356.398L497.119 355.986L497.651 355.532L498.079 355.041L498.394 354.521L498.593 353.986",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M812.759 269.676L812.003 270.205L811.162 270.69L810.246 271.121L809.257 271.502L808.211 271.824L807.112 272.085L805.978 272.28L804.813 272.416L803.632 272.479H802.448L801.267 272.409L800.105 272.277L798.968 272.076L797.875 271.811L796.829 271.49L795.844 271.109L794.927 270.671L794.089 270.186L793.34 269.657L792.682 269.087L792.124 268.482L791.674 267.849L791.331 267.193L791.101 266.521L790.987 265.839L790.99 265.154L791.107 264.473L791.34 263.802L791.686 263.147L792.143 262.514L792.704 261.911L793.365 261.342",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M112.145 245.431L107.166 245.819L102.173 246.139L97.1688 246.392L92.1554 246.579L87.1359 246.698L82.1134 246.749L77.0899 246.734L72.0682 246.651L67.0513 246.501L62.042 246.283",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M440.052 466.842L438.808 467.333L437.501 467.765L436.137 468.133L434.726 468.435L433.277 468.672L431.8 468.838L430.304 468.939L428.799 468.968L427.297 468.924L425.804 468.813L424.33 468.631L422.888 468.382L421.486 468.064L420.132 467.686L418.838 467.242L417.609 466.741L416.454 466.184L415.38 465.573L414.394 464.914L413.506 464.215L412.718 463.475L412.038 462.697L411.468 461.894L411.011 461.066L410.671 460.219L410.454 459.359L410.356 458.493L410.378 457.624L410.526 456.758L410.794 455.901L411.178 455.063L411.679 454.241L412.296 453.451L413.021 452.689L413.849 451.961L414.775 451.278L415.795 450.638",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M158.14 254.902L156.287 255.029L154.426 255.098L152.56 255.109L150.696 255.062L148.84 254.955L146.997 254.792L145.171 254.57L143.369 254.292L141.595 253.958L139.856 253.569L138.156 253.126L136.499 252.63L134.892 252.084L133.339 251.487L131.843 250.843L130.411 250.154L129.045 249.42L127.75 248.645",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4922 259.046L67.5441 259.484L67.6991 259.915L67.9542 260.329L68.3044 260.719L68.7434 261.078L69.2634 261.4L69.8539 261.677L70.5045 261.906L71.2027 262.081L71.9362 262.199L72.6905 262.259H73.4517L74.2063 262.199L74.9394 262.081L75.6376 261.906L76.2883 261.677L76.8791 261.4L77.3988 261.078L77.8378 260.719L78.188 260.329L78.4431 259.915L78.598 259.484L78.65 259.046L78.598 258.607L78.4431 258.177L78.188 257.763L77.8378 257.372L77.3988 257.013L76.8791 256.692L76.2883 256.414L75.6376 256.186L74.9394 256.011L74.2063 255.892L73.4517 255.832H72.6905L71.9362 255.892L71.2027 256.011L70.5045 256.186L69.8539 256.414L69.2634 256.692L68.7434 257.013L68.3044 257.372L67.9542 257.763L67.6991 258.177L67.5441 258.607L67.4922 259.046Z",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M541.782 294.131L543.143 293.394L544.585 292.708L546.097 292.078L547.675 291.505L549.315 290.988L551.01 290.538L552.751 290.147L554.531 289.823L556.342 289.568L558.178 289.376",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M498.593 328.173L498.426 328.646L498.167 329.102L497.821 329.54L497.396 329.956L496.889 330.337L496.312 330.687L495.673 330.995L494.977 331.26L494.234 331.48L493.453 331.647L492.643 331.767L491.818 331.83L490.984 331.842L490.152 331.798",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M396.746 164.535L396.321 164.735L395.839 164.884L395.316 164.975L394.771 165.006L394.226 164.975L393.704 164.884L393.222 164.735L392.8 164.535",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M471.754 330.242L470.938 330.148L470.145 329.997L469.389 329.801L468.674 329.553L468.009 329.263L467.408 328.932L466.873 328.564L466.413 328.164L466.032 327.735L465.739 327.285L465.534 326.819L465.418 326.343L465.396 325.865L465.468 325.386",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M548.188 213.409L549.331 213.335L550.458 213.203L551.56 213.014L552.631 212.769L553.658 212.471L554.637 212.121L555.557 211.723L556.414 211.28L557.201 210.794L557.91 210.271L558.533 209.713L559.072 209.126L559.516 208.514L559.868 207.881L560.12 207.233L560.272 206.575L560.322 205.911",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M495.834 335.521L495.182 335.852L494.464 336.126L493.686 336.346L492.864 336.503L492.014 336.595L491.151 336.623L490.288 336.582",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M555.853 211.605L554.934 212.084L553.932 212.506L552.865 212.867L551.737 213.163L550.563 213.391L549.353 213.548L548.125 213.633",
    stroke: "#50226D",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServalBlueprintIsometric);
export default __webpack_public_path__ + "static/media/serval-blueprint-isometric.4e6ed2a3459191c27b0ac669d604d8d7.svg";
export { ForwardRef as ReactComponent };